import React, { Component } from 'react';
import './styles/player-controls.css';
import PlayerControlsLiveTS from './PlayerControlsLiveTS'; // Con Timeshift
import PlayerControlsLive from './PlayerControlsLive'; // Sin timeshift
import PlayerControlsStartover from './PlayerControlsStartover';
import PlayerControlsCatchup from './PlayerControlsCatchup';
import PlayerControlsNpvr from './PlayerControlsNpvr';
import PlayerControlsVod from './PlayerControlsVod';
import PlayerControlsEmpty from './PlayerControlsEmpty';
import PlayerControlsLogic from './PlayerControlsLogic';
import Utils from '../../utils/Utils';
import {
    AAF_CONTENT_IS_NPVR,
    AAF_CONTENT_IS_VOD,
    AAF_CONTENT_IS_CATCHUP,
    AAF_CONTENT_IS_STARTOVER,
    AAF_CONTENT_IS_TV,
    AAF_CONTENT_IS_AUDIO,
    AAF_CONTENT_IS_RADIO
} from './../../AAFPlayer/constants';
import { isPreviewSong } from '../../actions/musica/player-shared-action-creators';
import EpgPersistence from '../../AAF/Nepg/EpgPersistence';
import LayersControl from '../../utils/LayersControl';
import Device from '../../devices/device';
import FallbackUtil from '../../components/Video/FallbackUtil';
import {
    videoControlWidth,
    videoControlHeight
} from './common/constants';
import { HideMiniEpgFromNewPlayerControlsObserver, HideMiniObserver, HidePlayerControlsObserver, ShowMiniObserver, ShowPlayerControlsObserver, UpdateMiniObserver } from '../../components/PersistentMiniEpg/MiniObserver';
import EventTimeshift from '../../AAF/Timeshift/EventTimeshift';
import AAF from '../../AAF/AAF';

import Mini from '../../components/PersistentMiniEpg';
import MiniEpgOtt from '../../components/PersistentMiniEpg/MiniEpgOtt';
import store from '../../store';
import CodeToVal from '../../utils/CodeToVal';
import TvChannelUtil from '../../utils/TvChannelUtil';
import PlayerStreamingUtils from '../../utils/PlayerStreamingUtils';
import ChannelSingleton from '../../components/Epg/ChannelsSingleton';
import ColoredBar from '../../components/ColoredBar';
import {
    HIDE_MODAL,
    MODAL_LANGUAGES,
    MODAL_OPTIONS_EPISODES,
    showModal,
    MODAL_INACTIVITY
} from '../../actions/modal';
import ModalEpgUtils from '../../components/Epg/ModalEpgUtils';
import { Dates } from '../../packages/dates';
import { NpvrUtil } from '../../AAF/Npvr/NpvrUtil';
import * as EventOptionsUtils from '../../components/EventOptions/EventOptionsUtils';
import { showFunctionNotAvailableNotification, showPlayerBackwardForwardNotAvailableNotification } from '../../actions/notification';
import Translator from '../../requests/apa/Translator';
import settings from '../../devices/all/settings';
import SkipIntro from './common/SkipIntro';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import ModelDetection from '../../utils/ModelDetection';
import { RecordingsNotification } from '../../components/PersistentMiniEpg/MiniObserver';
import channelStreamUtil from '../../utils/ChannelStreamUtil';
import {
    PlayerControlsActivityNotifier,
    PlayerControlsActivity,
    SHOW_SKIP_INTRO_EVENT,
    SEEK_VOD_PLAYER_CONTROLS_EVENT,
    RESET_AUTOHIDE_VOD_PLAYER_CONTROLS_EVENT
} from './PlayerControlsActivity';
import { ThirdPartyEpgHelper } from '../../AAFPlayer/helpers/ThirdPartyEpgHelper';
import {GA4} from '../../utils/trackers/GA4';
import asyncPinObserver from '../../AAF/Pin/AsyncPinObserver';
import { modalInactivityCountLIVESeries } from 'src/components/Modal/functions/ModalInactivity/index'
import UtilsClaroPagos from '../../utils/payway/claroPagos';
import { setValuesStoreModalKeepWatching } from 'src/components/Modal/functions/ModalKeepWatching/functions';
import { ClearTextSearch } from '../../components/PersistentMiniEpg/MiniObserver';
import {removeDynamicFocus} from "../../components/Focus/utils";

const RED_BUTTON = 'RED';
const YELLOW_BUTTON = 'YELLOW';
const GREEN_BUTTON = 'GREEN';
const BLUE_BUTTON = 'BLUE';
const CSSNAME_FOCUSABLE_COLORED_BUTTONS = 'whenfocusable pc-colored-button-yellow';

const PLAYERCONTROLS_FOCUS_ZONE = 'n_player_controls';
const SKIPINTRO_FOCUS_ZONE = 'n_player_controls_skip_intro';
const COLOREDBAR_FOCUS_ZONE_PLAYERCONTROLS = 'n_player_controls_colored_bar_playercontrols_zone';
const COLOREDBAR_FOCUS_ZONE_MINIEPG = 'n_player_controls_colored_bar_miniepg_zone';

class PlayerControls extends Component {

    static isVisible = true;

    constructor(props) {
        super(props);

        this.timeEndLabel = '--:--:--';
        this.state = {
            visible: false, // Estatus de player controls, visible o no, este estado NO se usa para modificar el hide o el visible en el render, en su lugar se usa refs para evitar el reset de PC y que haga cosas extrañas como adelantar o atrasar el slider a cada que se muestra u oculta
            miniEpgVisible: false,
            playing: false,
            // Abajo la info de evento, uno es para evento de canal con TS y el otro es para
            // evento de canal SIN TS, se tuvo que poner así porque sobre el evento con TS (timeshiftEventInfo)
            // ya se hacen diferentes
            // validaciones para funciones de TS (record, trick mode, tipos de controls en player controls, etc.)
            // El otro, el evento de canal sin TS (normalEventInfo) se usa poara la modal de cambio de lenguaje
            timeshiftEventInfo: null, // El evento de un canal con TS
            normalEventInfo: null, // El evento de un canal sin TS
            contentStreamType: null,
            channelInfo: null,
            serieData: null,

            // Tiene o no skip intro
            hasSkipIntro: false,
            // Esta skip intro visible
            skipIntroVisible: false,
            skipIntroStartTime: 0,
            skipIntroEndTime: 0, // Es el tiempo real que viene de API
            skipIntroCalculatedEndTime: 0, // Es el tiempo que se calcula de manera local, de acuerdo a la llave additional_autoHide_skipIntro_seconds
            justWasSkipIntroShowedFirstTime: false,
            justWasSkipIntroClosedFirstTime: false
        };

        // Internal state
        this.isMoving = false; // VOD slide
        this.duration = 0;
        this.currentTime = 0;
        this.canPlay = false;
        this.currentEvent = null;
        this.timer = null;
        this.languageOptions = [];
        this.currentLangChapter = [];

        // Sprite
        this.contentSprite = null;
        this.proporcion = 0;

        // Cambio de canal numérico
        this.playerStreamingUtils = new PlayerStreamingUtils();
        this.timerDelayChannelChange = null;
        this.lastNumberPressed = '';
        this.maxLenNumberChannel = 4;
        this.delayChannelChange = 1500;
        this.recordingsEnabled = NpvrUtil.recordingIconEnable().enable;

        // Animate colored bar
        this.settings_animateColoredBar = {
            enable: Utils.playerEnableAnimation(),
            animatedIntervalID: null,
            animatedIntervalMS: 3,
            animatedIntervalHightPos: 0,
            animatedIntervalLowPos: -40, // Same value must be in scss of this component
            animatedIntervalStep: 8,
            animatedIntervalStepSimulated: 4
        };

        // RCU keys to map RCU actions/clicks
        this.keys = Device.getDevice().getKeys();
        this.codeToVal = new CodeToVal();

        this.playerAlreadyHasVideo = true;
        this.playerSetTimeshiftEventInfoCounter = 0;

        // Please bind...
        this.keyPressHandler = this.keyPressHandler.bind(this);
        this.hide = this.hide.bind(this);
        this.back = this.back.bind(this);
        this.onDurationChange = this.onDurationChange.bind(this);
        this.setDuration = this.setDuration.bind(this);
        this.getDuration = this.getDuration.bind(this);
        this.onPause = this.onPause.bind(this);
        this.onPlay = this.onPlay.bind(this);
        this.onBackward = this.onBackward.bind(this);
        this.onForward = this.onForward.bind(this);
        this.onSlide = this.onSlide.bind(this);
        this.onIsMoving = this.onIsMoving.bind(this);
        this.onToggleEpg = this.onToggleEpg.bind(this);
        this.enabledForThisContentStreamType = this.enabledForThisContentStreamType.bind(this);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.showMini = this.showMini.bind(this);
        this.hideMini = this.hideMini.bind(this);
        this.toggleControls = this.toggleControls.bind(this);
        this.onShowLanguages = this.onShowLanguages.bind(this);
        this.onRecording = this.onRecording.bind(this);
        this.enableButton = this.enableButton.bind(this);
        this.goToCard = this.goToCard.bind(this);
        this.setChannelInfo = this.setChannelInfo.bind(this);
        this.getContentStreamType = this.getContentStreamType.bind(this);
        this.getStreamType = this.getStreamType.bind(this);
        this.isMultipleLiveLangEnabled = this.isMultipleLiveLangEnabled.bind(this);
        this.eventIsRecording = this.eventIsRecording.bind(this);
        this.resetAutoHideTimer = this.resetAutoHideTimer.bind(this);
        this.autoHide = this.autoHide.bind(this);
        this.stopAutoHideTimer = this.stopAutoHideTimer.bind(this);
        this.handleEndPlayer = this.handleEndPlayer.bind(this);
        this.manageRedButton = this.manageRedButton.bind(this);
        this.manageYellowButton = this.manageYellowButton.bind(this);
        this.manageBlueButton = this.manageBlueButton.bind(this);
        this.manageGreenButton = this.manageGreenButton.bind(this);
        this.getLanguageOptions = this.getLanguageOptions.bind(this);
        this.skipIntroControl = this.skipIntroControl.bind(this);
        this.doSkipIntro = this.doSkipIntro.bind(this);
        // this.updateCurrentTimeSprite = this.updateCurrentTimeSprite.bind(this);
        this.getCurrentTimeAsString = this.getCurrentTimeAsString.bind(this);
        this.getAbsoluteElementPosition = this.getAbsoluteElementPosition.bind(this);
        this.updateSpritePosition = this.updateSpritePosition.bind(this);
        this.hideSprites = this.hideSprites.bind(this);
        this.showSprites = this.showSprites.bind(this);
        this.canShowSprites = this.canShowSprites.bind(this);
        this.updateSprite = this.updateSprite.bind(this);
        this.changeLang = this.changeLang.bind(this);
        this.onSelectEpisodes = this.onSelectEpisodes.bind(this);
        this.animateColoredBar = this.animateColoredBar.bind(this);
        this.getColoredBarControlsNavigation = this.getColoredBarControlsNavigation.bind(this);
        this.hideAll = this.hideAll.bind(this);
        this.handleRecordingsNotification = this.handleRecordingsNotification.bind(this);
        this.getEventRecordingStatus = this.getEventRecordingStatus.bind(this);
        this.getNowEventCb = this.getNowEventCb.bind(this);
        this.getNowEvent = this.getNowEvent.bind(this);
        this.requestEventInPlay = this.requestEventInPlay.bind(this);
        this.showNotificationNoSlide = this.showNotificationNoSlide.bind(this);
        this.hideMiniEpgWithVisibilityValidation = this.hideMiniEpgWithVisibilityValidation.bind(this);
        this.notifyActivity = this.notifyActivity.bind(this);
        this.seek = this.seek.bind(this);
        this.setNormalEventInfo = this.setNormalEventInfo.bind(this);
        this.whenPlayerHasVideo = this.whenPlayerHasVideo.bind(this);
        this.sendGA4Metric = this.sendGA4Metric.bind(this);
        this.fireTPAApp = this.fireTPAApp.bind(this);
        this.fireTPAAppResult = this.fireTPAAppResult.bind(this);
        this.workflowInBack = this.workflowInBack.bind(this);
        asyncPinObserver.subscribe(this.whenPlayerHasVideo);


        // Para cuando conviva con la mini old
        this.onHideListeners = [];

        this.initSpriteConfig();

        this.playerControlsActivityNotifier = new PlayerControlsActivityNotifier();
        this.playerControlsActivityNotifier.subscribe(this);
        this.history = props && (props.history || null);
    }

    /**
     * playerControlsActivity = {
     *  eventName,
     *  data
     * }
     */
    notifyActivity(playerControlsActivity) {
        // Por el monento esto nomás es para VOD
        if (this.state.contentStreamType !== AAF_CONTENT_IS_VOD) return;

        // Tiempo de autohide de la mini
        const autoHidePlayerControlsTime = this.getPlayerControlsMiniAutoHideSeconds();
        // Tiempo de add seconds del skip
        const addSkip = this.getAdditionalautoHideSkipSeconds();
        // Current time
        const currentTime = this.getCurrentTime();

        let _log = '';
        switch (playerControlsActivity.eventName) {
            case SHOW_SKIP_INTRO_EVENT:
                // Si el skip intro es llamado de manera manual 'desde show player por algun evento del user'
                if (playerControlsActivity.data.calledFromShowPlayer) {
                    let endTimeSkip = parseInt(currentTime) + parseInt(addSkip) + parseInt(autoHidePlayerControlsTime);
                    if (endTimeSkip > parseInt(this.state.skipIntroEndTime)) {
                        endTimeSkip = parseInt(this.state.skipIntroEndTime);
                    }

                    _log = `[SKI] ACTIVITY SHOW_SKIP_INTRO_EVENT ajuste currentTime ${currentTime} + 5 + 7: ${endTimeSkip}`;

                    console.log(_log);
                    this.setState({
                        skipIntroCalculatedEndTime: endTimeSkip
                    });
                }
                // // Si el skip intro es llamado de manera automática 'el progress time llegó al start intro time'
                // else {
                //     let endTimeSkip = parseInt(this.state.skipIntroStartTime) + parseInt(addSkip);
                //     if(endTimeSkip > parseInt(this.state.skipIntroEndTime)) {
                //         endTimeSkip = parseInt(this.state.skipIntroEndTime);
                //     }
                //     console.log('[SKI], ACTIVITY SHOW_SKIP_INTRO_EVENT se mostró skip solito, AJUSTE END TIME SKIP: ', endTimeSkip, 's');
                //     this.setState({
                //         skipIntroCalculatedEndTime: endTimeSkip
                //     });
                // }
                break;
            case SEEK_VOD_PLAYER_CONTROLS_EVENT:
                // Verificar si en el seek se llegó al rango de show intro
                const seekTo = parseInt(playerControlsActivity.data.seekTo);
                if (seekTo > 0) {
                    if (this.state.hasSkipIntro
                        && seekTo >= parseInt(this.state.skipIntroStartTime)
                        && seekTo <= parseInt(this.state.skipIntroEndTime)) {
                        let endTimeSkip = seekTo + parseInt(addSkip) + parseInt(autoHidePlayerControlsTime);
                        if (endTimeSkip > parseInt(this.state.skipIntroEndTime)) {
                            endTimeSkip = parseInt(this.state.skipIntroEndTime);
                        }
                        _log = `[SKI] ACTIVITY SEEK_VOD_PLAYER_CONTROLS_EVENT ajuste seekTo ${seekTo} + 5 + 7: ${endTimeSkip}`;
                        console.log(_log);

                        this.setState({
                            skipIntroCalculatedEndTime: endTimeSkip
                        });
                    }
                    else {
                        // Verificar si hizo un seek y se saltó el intro
                        if (!this.state.justWasSkipIntroShowedFirstTime) {
                            if (seekTo > parseInt(this.state.skipIntroStartTime)) {
                                console.log('[SKI] se guarda que ya mostró el skip button porque el seek se pasa del rango de tiempo para el skip button');
                                this.setState({
                                    justWasSkipIntroShowedFirstTime: true
                                });
                            }
                        }
                    }
                }
                break;
            case RESET_AUTOHIDE_VOD_PLAYER_CONTROLS_EVENT:
                if (this.state.visible && this.state.skipIntroVisible) {
                    /**
                     * Si están visibles ambos, player y skip se agrega más tiempo al intro en pantalla
                     */
                    let endTimeSkip = parseInt(currentTime) + parseInt(addSkip) + parseInt(autoHidePlayerControlsTime);
                    if (endTimeSkip > parseInt(this.state.skipIntroEndTime)) {
                        endTimeSkip = parseInt(this.state.skipIntroEndTime);
                    }
                    _log = `[SKI] ACTIVITY RESET_AUTOHIDE_VOD_PLAYER_CONTROLS_EVENT (playerControls y skipIntro visibles) ajuste currentTime ${currentTime} + 5 + 7: ${endTimeSkip}`;
                    console.log(_log);
                    this.setState({
                        skipIntroCalculatedEndTime: endTimeSkip
                    });
                }
                else if (this.state.skipIntroVisible) {
                    let endTimeSkip = parseInt(currentTime) + parseInt(addSkip) + parseInt(autoHidePlayerControlsTime);
                    if (endTimeSkip > parseInt(this.state.skipIntroEndTime)) {
                        endTimeSkip = parseInt(this.state.skipIntroEndTime);
                    }
                    _log = `[SKI] ACTIVITY RESET_AUTOHIDE_VOD_PLAYER_CONTROLS_EVENT (Sólo skipIntro visible) ajuste currentTime ${currentTime} + 5 + 7: ${endTimeSkip}`;
                    console.log(_log);
                    this.setState({
                        skipIntroCalculatedEndTime: endTimeSkip
                    });
                }
                break;
            default:
                break;
        }
    }

    handleRecordingsNotification(recordingResult) {
        // Update botón de recording, sin setstate ¿?
        if(recordingResult.eventId === this.state.timeshiftEventInfo.event.id){
                switch (this.state.contentStreamType) {
                    case AAF_CONTENT_IS_STARTOVER:
                    case AAF_CONTENT_IS_CATCHUP:
                    case AAF_CONTENT_IS_TV:
                        this.updateRecordingState(recordingResult);
                        break;
                    default:
                        break
                }
            }
    }

    updateRecordingState(recordingResult) {
        const timeshiftEventInfo = this.state.timeshiftEventInfo;
        if (timeshiftEventInfo && timeshiftEventInfo.event && !isNaN(timeshiftEventInfo.event.recording_status)) {
            timeshiftEventInfo.event.recording_status = recordingResult.recording_status;
            this.setTimeshiftEventInfo(timeshiftEventInfo);
        }
    }

    getPlayerControlsMiniAutoHideSeconds() {
        return Utils.miniFullEpgAutoHideSeconds(
            'mini_epg_auto_hide_seconds',
            7
        );
    }

    resetAutoHideTimer() {
        console.log('[AHIDE] startAutoHideTimer');
        this.stopAutoHideTimer();
        const autoHideMiniEpgSeconds = this.getPlayerControlsMiniAutoHideSeconds();
        const time = isNaN(autoHideMiniEpgSeconds) ? 20000 : autoHideMiniEpgSeconds * 1000;
        this.timer = setInterval(this.autoHide, time);
    }

    stopAutoHideTimer() {
        console.log('[AHIDE] stopAutoHideTimer');
        if (!this.timer) return;
        clearInterval(this.timer);
        this.timer = null;
    }

    autoHide() {
        this.stopAutoHideTimer();
        // Aquí verificar por ejemplo en el skip intro? que no se oculte?
        console.log('[WHENPAUSE] entra en autoHide se oculta todo');
        if (this.state.visible) this.hide();
        if (this.state.miniEpgVisible) this.hideMini();
    }

    onUpdateLangOptions(langOptions, isResumeAfterIntro = false, resumeSecond = 0) {
        console.log('[MA-LIVE]-langOptions', langOptions);
        console.log('[SKI] onUpdateLangOptions isResumeAfterIntro: ', isResumeAfterIntro);
        this.languageOptions = langOptions;
        this.state.contentStreamType === AAF_CONTENT_IS_VOD && this.skipIntroControl(langOptions, isResumeAfterIntro, resumeSecond);
    }

    getLanguageOptions() {
        return this.languageOptions;
    }

    setChannelInfo(channelInfo) {
        this.setState({ channelInfo });
    }

    updateCurrentTime(currentTime) {
        this.state.contentStreamType === AAF_CONTENT_IS_VOD && this.handleSkipIntro();
        this.setCurrentTime(currentTime);

        if (settings.player_controls_enable_screen_seconds) {
            if (this.refs['ctime']) {
                this.refs['ctime'].innerHTML = Math.floor(currentTime) + 's';
            }
        }

        if (this.refs['playerControls']) {
            this.refs['playerControls'].updateCurrentTime(currentTime);
        }
    }

    onToggleEpg() {
        console.log('[NPC] onToggleEpg');
        // los hide's ya resetean el timer para autohide
        if (this.state.visible) this.hide();
        if (this.state.miniEpgVisible) this.hideMini();

        PlayerControlsLogic.sendMetric('click', 'guia', this.props.dataMetric, this.props.setMetricsEvent, false, this.getCurrentTimeInMinutes(), this.getDurationInMinutes());

        this.props.handleFullEpg('GUIDE');
    }

    getDurationInMinutes() {
        return (this.getDuration() / 60.0).toFixed();
    }

    getCurrentTimeInMinutes() {
        return (this.getCurrentTime() / 60.0).toFixed();
    }

    onShowLanguages(data) {
        if (!this.canPlay) return;
        this.sendGA4Metric('G5');
        const streamType = this.getStreamType();
        if (this.state.contentStreamType === AAF_CONTENT_IS_VOD) {
            // hide's ya hacen stop del timer autohide
            if (this.state.visible) this.hide(); //

            // Para recuperar data cuando usen LANG desde el RCU en VOD
            if (!data) {
                if (this.refs.playerControls && this.refs.playerControls.getDataContentTitle) {
                    const { contentTitleNormal = '', contentSerieEpisodeTitle = '', description = '', duration = null } = this.refs.playerControls.getDataContentTitle() || {};
                    data = {
                        title: contentTitleNormal,
                        contentSerieEpisodeTitle,
                        description,
                        duration
                    }
                }
            }

            if (data && (typeof data === 'object')) {
                data.languageOptions = this.getLanguageOptions();
            }

            // PlayerControlsLogic.sendMetric('control player', 'idioma', this.props.dataMetric, this.props.setMetricsEvent, false, this.getCurrentTimeInMinutes(), this.getDurationInMinutes(), 'reproductor');

            ModalEpgUtils.blueHandler({
                hideEpgOutsideCb: null,
                handleGuideCb: null,
                data,
                streamType,
                streamContentType: this.state.contentStreamType,
                changeLangCb: this.changeLang,
                onClose: () => {
                    this.show();
                }
            });
        }
        else {
            // hide's ya hacen stop del timer autohide
            if (this.state.visible) this.hide();
            if (this.state.miniEpgVisible) this.hideMini();

            PlayerControlsLogic.sendMetric('click', 'idioma', this.props.dataMetric, this.props.setMetricsEvent, false, this.getCurrentTimeInMinutes(), this.getDurationInMinutes());

            ModalEpgUtils.blueHandler({
                hideEpgOutsideCb: null,
                handleGuideCb: null,
                data: this.requestEventInPlay(),
                streamType,
                streamContentType: this.state.contentStreamType,
                changeLangCb: this.props.changeLang,
                keyFrom: 'SUB_AUD'
            });
        }
    }

    // TODO implementar el change lang en live flavours & vod
    changeLang(e) {
        // TO DO PAU
        // if (this.seekInPause) {
        //   e.resume = this.seekInPause;
        // }
        const actions = {
            play: () => { this.props.play() },
            resetSeekInPause: () => { }//this.resetSeekInPause()
        };
        // Asi estaba antes
        try {
            PlayerControlsLogic.sendMetric('idioma', e.label_short, this.props.dataMetric, this.props.setMetricsEvent, false, this.getCurrentTimeInMinutes(), this.getDurationInMinutes());
            (typeof this.props.changeLang === 'function') && this.props.changeLang(e, actions);
            //Fix oculta player controls, para no mostrar el resete en el current time al hacer cambio de idioma
            //   this.hide();
        } catch (e) {
            console.error('Error changeLang:', e);
        }

        //
    }

    // TODO implementar cambio de episodio, VOD
    changeEpisode(episode = {}) {
        PlayerControlsLogic.sendMetric('cambiar episodio ' + episode.title_episode, null, this.props.dataMetric, this.props.setMetricsEvent, false, this.getCurrentTimeInMinutes(), this.getDurationInMinutes());
    }

    onRecording(e, showOption = true) {
        if (!showOption) return;

        if (!this.state.timeshiftEventInfo) {
            if (this.state.visible) this.hide();
            this.props.showPlayerEventRecordingNotAvailableNotification();
            return;
        }

        // hide's ya hacen stop del timer autohide
        if (this.state.visible) this.hide();
        if (this.state.miniEpgVisible) this.hideMini();
        const currentEvent = this.requestEventInPlay();

        const event = { ...currentEvent };
        if (NpvrUtil.viewButtonRecording({ event: currentEvent })) {
            typeof this.props.record === 'function' && this.props.record(event);
            PlayerControlsLogic.sendMetric('click', 'grabar', this.props.dataMetric, this.props.setMetricsEvent, false, this.getCurrentTimeInMinutes(), this.getDurationInMinutes());
        }
        else {
            this.props.showPlayerEventRecordingNotAvailableNotification();
        }

        //se toma el this.currentEvent para tener el evento focuseado y se pone al inicio porque al hacer el hide mini el current event se reinicia
        // const event = this.state && this.state.timeshiftEventInfo &&  this.state.timeshiftEventInfo.event;
        // event && this.props && typeof this.props.record === 'function' && this.props.record(event);
    }

    whenPlayerHasVideo(who) {
        // Cuando se inicia el play se manda este stat
        if (who === 'player_starts') {
            this.playerAlreadyHasVideo = true;
            /**
             * Para catchup, VOD, npvr entra aquí al iniciar video
             *
             * Para live tv y startover la métrica se manda desde método setTimeshiftEventInfo()
             */
             switch(this.state.contentStreamType) {
                case AAF_CONTENT_IS_CATCHUP:
                case AAF_CONTENT_IS_VOD:
                case AAF_CONTENT_IS_NPVR:
                    this.sendGA4Metric('G1');
                    break;
                    default:
                    break;
             }
        }
        else {
            this.playerAlreadyHasVideo = false;
            this.playerSetTimeshiftEventInfoCounter = 0;
        }
    }

    sendGA4Metric(ga4Id, progress_percentage){
        const ga4 = new GA4();
        let {playerContentData, playerContentData: {item_id,  item_name, item_category, item_category2, item_category3, item_category4, content_list} = {}} = store.getState() || {};
        switch(this.state.contentStreamType) {
            case AAF_CONTENT_IS_TV:
            case AAF_CONTENT_IS_STARTOVER:
            case AAF_CONTENT_IS_CATCHUP:
                item_id = this.state.timeshiftEventInfo && this.state.timeshiftEventInfo.event && this.state.timeshiftEventInfo.event.group_id;
                item_name = this.state.timeshiftEventInfo && this.state.timeshiftEventInfo.event && this.state.timeshiftEventInfo.event.name;
                item_category = 'canal tv';
                item_category2 = '';
                item_category3 = '';
                item_category4 = 'no aplica';
                content_list = 'no aplica';
            break;
            case AAF_CONTENT_IS_NPVR:
                let _item_id = null;
                if(this.state.timeshiftEventInfo && this.state.timeshiftEventInfo.event && this.state.timeshiftEventInfo.event.event_alf_id) {
                    _item_id = this.state.timeshiftEventInfo.event.event_alf_id;
                }
                else if(this.state.timeshiftEventInfo && this.state.timeshiftEventInfo.event && this.state.timeshiftEventInfo.event.event_id) {
                    _item_id = this.state.timeshiftEventInfo.event.event_id;
                }
                else {
                    _item_id = 'noId';
                }
                item_id = _item_id;
                item_name = this.state.timeshiftEventInfo && this.state.timeshiftEventInfo.event && this.state.timeshiftEventInfo.event.title;
                item_category = 'canal tv';
                item_category2 = '';
                item_category3 = '';
                item_category4 = 'no aplica';
                content_list = 'no aplica';
            break;
            case AAF_CONTENT_IS_VOD:
            default:
            break;
        }

        if(!item_id) {
            item_id = '';
            item_name = '';
            item_category = 'canal tv';
            item_category2 = '';
            item_category3 = '';
            item_category4 = '';
            content_list = '';
        }

        switch (ga4Id) {
            case 'G1':
                // public sendPlayContentEvent(id:, name, type, category, availability, episode, list)
                ga4.sendPlayContentEvent(item_id,item_name,item_category,item_category2,item_category3,item_category4, content_list);
                break;
            case 'G2':
                ga4.sendPauseContentEvent(item_id,item_name,item_category,item_category2,item_category3,item_category4, content_list);
                break;
            case 'G3':
                ga4.sendBackContentEvent(item_id,item_name,item_category,item_category2,item_category3,item_category4, content_list);
                break;
            case 'G4':
                ga4.sendAdvanceContentEvent(item_id,item_name,item_category,item_category2,item_category3,item_category4, content_list);
                break;
            case 'G5':
                ga4.sendInteractionContentEvent(item_id,item_name,item_category,item_category2,item_category3,item_category4, content_list);
                break;
            case 'G6':
                ga4.sendProgressContentEvent(item_id,item_name,item_category,item_category2,item_category3,item_category4,content_list ,progress_percentage);
                break;
            default:
                break;
        }
    }

    componentWillMount() {
        console.log('[NPC] DM PlayerControls Nuevo willMount');
    }

    componentDidMount() {
        this.onCanPlay();
        // window.SpatialNavigation.enable('n_player_controls');
        RecordingsNotification.unsubscribe(this.handleRecordingsNotification);
        RecordingsNotification.subscribe(this.handleRecordingsNotification);

        this.addEventListeners();
        this.focus('.video-player-control-main-button');

        if (this.state.contentStreamType !== this.props.nextContentStreamType) {
            console.log('[SCT1] DM PlayerControls componentDidMount, se hace SET STATE');
            this.setState({
                contentStreamType: this.props.nextContentStreamType
            }, () => {
                this.resolvePlayerControls(this.props.nextContentStreamType, null);
            });
        }
        // window.SpatialNavigation.focus('.video-player-control-button .focusable');
    }

    async componentDidUpdate() {
        console.log('[NPC] PlayerControls React-cycle componentDidUpdate');
        this.state.contentStreamType === AAF_CONTENT_IS_TV && await modalInactivityCountLIVESeries()
    }

    diffProps(nextProps) {
        // El orden de las properties importa, mantener el mismo orden
        const _nextProps = {
            checkStatusEPG: nextProps.checkStatusEPG || null,
            groupId: nextProps.groupId || null,
            nextContentStreamType: nextProps.nextContentStreamType || null
        };

        const _currentProps = {
            checkStatusEPG: this.props.checkStatusEPG || null,
            groupId: this.props.groupId || null,
            nextContentStreamType: this.props.nextContentStreamType || null
        };

        return JSON.stringify(_nextProps) !== JSON.stringify(_currentProps);
    }

    /**
     * @param {*} nextProps
     *
     * Aquí intentamos controlar qué se muestra al inicio de
     * una reproducción? por ejemplo en TV al ingresar al nodo TV se muestra
     * la mini.
     */
    componentWillReceiveProps(nextProps) {
        console.log('[NPCWILL] Player controls enter willReceive, nextProps: ', nextProps);

        if (this.state.contentStreamType !== nextProps.nextContentStreamType) {

            // Va de live a st?
            let fromLiveToSt = false;
            if (this.state.contentStreamType === AAF_CONTENT_IS_TV && nextProps.nextContentStreamType === AAF_CONTENT_IS_STARTOVER) {
                fromLiveToSt = true;
            }

            // Va de st a live?
            let fromStToLive = false;
            if (this.state.contentStreamType === AAF_CONTENT_IS_STARTOVER && nextProps.nextContentStreamType === AAF_CONTENT_IS_TV) {
                fromStToLive = true;
            }

            const nextState = {
                contentStreamType: nextProps.nextContentStreamType,
                timeshiftEventInfo: null,
                serieData: null
            };

            this.duration = 0;
            this.currentTime = 0;
            this.canPlay = false;
            this.currentEvent = null;

            this.setState(nextState, () => {
                this.resolvePlayerControls(nextProps.nextContentStreamType, nextProps, fromLiveToSt, fromStToLive);
            });
        }
        else {
            switch (nextProps.nextContentStreamType) {
                case AAF_CONTENT_IS_TV:
                    const { groupId = null } = this.props;
                    let diff = false;
                    if (
                        (nextProps.groupId && nextProps.groupId !== groupId) ||
                        (nextProps.groupId && nextProps.groupId !== TvChannelUtil.getLastChannel())
                    ) {
                        diff = true;
                    }
                    if (diff) {
                        if (nextProps.groupId) {
                            if(!this.isTPA(nextProps.groupId) || !DeviceStorage.getItem("fireTPAOnReload")){
                                TvChannelUtil.setLastChannel(nextProps.groupId)
                            }
                        }
                        UpdateMiniObserver.fire(null);

                        let isTPA = false;
                        if (nextProps && nextProps.groupId) {
                            isTPA = this.isTPA(nextProps.groupId);
                        }
                        if(nextProps && nextProps.groupId && !isTPA) {
                            if (!this.state.miniEpgVisible) {
                            this.showMini();
                            }
                        }
                        if(isTPA) {
                            if(this.state.miniEpgVisible) this.hideMini();
                        }
                    }
                    if (!nextProps.checkStatusEPG) {
                        // Si esta abierta la full
                        const fullOpen = Utils.isFullEpgPersistanceOpen();
                        const modalOpen = !Utils.isModalHide();

                        // const diffProps = this.diffProps(nextProps);
                        if (modalOpen) {
                            if (this.state.miniEpgVisible) this.hideMini();
                            if (this.state.visible) this.hide();
                            return;
                        }
                        // !fullOpen && this.resolvePlayerControls(nextProps.nextContentStreamType, nextProps);
                    }
                    break;
                case AAF_CONTENT_IS_CATCHUP:
                    // Set mini position to catchup event
                    console.log('[NPCWILL] Player controls catchup Update mini observer, es CTUP 1', nextProps, this.props);
                    if (nextProps.event) {
                        let diffc = false;
                        const { event = null } = this.props;

                        if (event && nextProps.event && nextProps.event.id && nextProps.event.id !== event.id) {
                            diffc = true;
                            console.log('[NPCWILL] se hace el updataMini CTUP');
                            diffc && UpdateMiniObserver.fire(nextProps.event);
                        }
                    }
                    break
                // TODO resolver cuando es catchup y va de catchup a catchup, para mantener la mini
                case AAF_CONTENT_IS_STARTOVER:
                case AAF_CONTENT_IS_NPVR:
                    break;
                case AAF_CONTENT_IS_VOD:
                    // Conservar serieData ¿?
                    break;
                default:
                    break;
            }
        }
        this.onCanPlay();
    }

    isTPA(groupId) {
        return ThirdPartyEpgHelper.isThirdPartyApp(groupId);
    }

    resolvePlayerControls(nextContentStreamType, nextProps, fromLiveToSt = false, fromStToLive = false) {
        // Resolver por streamType
        switch (nextContentStreamType) {
            // TODO controlar cuando es TV y se esta en pausa, es decir antes de entrar en startover
            case AAF_CONTENT_IS_TV:
                console.log('[NPCWILL] Player controls catchup Update mini observer, es TV 2');
                if (nextProps && nextProps.groupId) {
                    if(!this.isTPA(nextProps.groupId) || !DeviceStorage.getItem("fireTPAOnReload")){
                        TvChannelUtil.setLastChannel(nextProps.groupId)
                    }
                }
                UpdateMiniObserver.fire(null); // Reset mini to now event
                let isTPA = false;
                if (nextProps && nextProps.groupId) {
                    isTPA = this.isTPA(nextProps.groupId);
                }
                if(nextProps && nextProps.groupId && !fromStToLive && !isTPA) {
                    this.showMini();
                }
                if(isTPA) {
                    if(this.state.miniEpgVisible) this.hideMini();
                }
                break;
            case AAF_CONTENT_IS_STARTOVER: // Si esta en startover se muestra primero player controls
                // if (this.state.visible) this.hide();
                if (this.state.miniEpgVisible) this.hideMini();
                fromLiveToSt ? this.show() : this.showMini();
                break;
            // Al igual que en VOD, al entrar por primera vez a NPVR no
            // se muestra nada
            case AAF_CONTENT_IS_NPVR:
            case AAF_CONTENT_IS_VOD:
                if (this.state.visible) this.hide();
                if (this.state.miniEpgVisible) this.hideMini();
                break;
            case AAF_CONTENT_IS_CATCHUP:
                // Set mini position to catchup event
                console.log('[NPCWILL] Player controls catchup Update mini observer, es CTUP 2');
                nextProps && nextProps.event && UpdateMiniObserver.fire(nextProps.event);
                this.showMini();
                break;
            default:
                break;
        }

        // Autohide
        this.resetAutoHideTimer();
    }

    setSerieData(serieData) {
        this.setState({ serieData });
    }

    setContentTitle(contentTitle) {
        if (this.refs.playerControls && this.refs.playerControls.setContentTitle) {
            this.refs.playerControls.setContentTitle(contentTitle);
        }
    }

    addEventListeners() {
        this.removeEventListeners();

        ShowPlayerControlsObserver.subscribe(this.toggleControls);
        HidePlayerControlsObserver.subscribe(this.hide);

        HideMiniEpgFromNewPlayerControlsObserver.subscribe(this.hideMiniEpgWithVisibilityValidation);
        if (
            navigator.userAgent.toLowerCase().indexOf('opera') !== -1 &&
            (navigator.userAgent.toLowerCase().indexOf('netrange') === -1 || navigator.userAgent.toLowerCase().indexOf('netrangemmh') === -1) &&
            Utils.deviceIsNotHisense()
        ) {
            window.removeEventListener('keydown', this.keyPressHandler, true);
            window.addEventListener('keydown', this.keyPressHandler, true);

            window.removeEventListener('sn:focused', this.onFocus, false);
            window.removeEventListener('sn:unfocused', this.onUnfocus, false);
            window.addEventListener('sn:focused', this.onFocus);
            window.addEventListener('sn:unfocused', this.onUnfocus);
            window.addEventListener(settings.end_vod_fire_event, this.handleEndPlayer);
        } else {
            document.removeEventListener('keydown', this.keyPressHandler, false);
            document.addEventListener('keydown', this.keyPressHandler, false);

            document.removeEventListener('sn:focused', this.onFocus, false);
            document.removeEventListener('sn:unfocused', this.onUnfocus, false);
            document.addEventListener('sn:focused', this.onFocus);
            document.addEventListener('sn:unfocused', this.onUnfocus);
            document.addEventListener(settings.end_vod_fire_event, this.handleEndPlayer);
        }

    }

    removeEventListeners() {
        if (
            navigator.userAgent.toLowerCase().indexOf('opera') !== -1 &&
            (navigator.userAgent.toLowerCase().indexOf('netrange') === -1 || navigator.userAgent.toLowerCase().indexOf('netrangemmh') === -1) &&
            Utils.deviceIsNotHisense()
        ) {
            window.removeEventListener('keydown', this.keyPressHandler, true);
            window.removeEventListener('sn:focused', this.onFocus);
            window.removeEventListener('sn:unfocused', this.onUnfocus);
            window.removeEventListener(settings.end_vod_fire_event, this.handleEndPlayer);

        } else {
            document.removeEventListener('keydown', this.keyPressHandler, false);
            document.removeEventListener('sn:focused', this.onFocus);
            document.removeEventListener('sn:unfocused', this.onUnfocus);
            document.removeEventListener(settings.end_vod_fire_event, this.handleEndPlayer);
        }

        ShowPlayerControlsObserver.unsubscribe(this.toggleControls);
        HidePlayerControlsObserver.unsubscribe(this.hide);
        HideMiniEpgFromNewPlayerControlsObserver.unsubscribe(this.hideMiniEpgWithVisibilityValidation);
    }

    handleEndPlayer() {
        if (this.state.visible) this.hide();
        if (this.state.miniEpgVisible) this.hideMini();
        if (this.state.skipIntroVisible) this.hideSkipIntro();
    }

    onFocus(e) {
        if (e.target.className.indexOf('video-player-control-button') !== -1) {
            // e.target.style.height = `${videoControlHeightOnFocus}px`;
            // e.target.style.width = `${videoControlWidthOnFocus}px`;
            const idn = +e.target.id.substring(2);
            const titlesb = Array.from(document.querySelectorAll('.video-player-control-button-title'));
            titlesb && Array.isArray(titlesb) && titlesb.length > 0 && titlesb.forEach((bt, idx) => {
                if (idx === idn) {
                    bt.classList.add('player-controls-vod-title-empha');
                }
            });
        }
        // else {
        //     if (e.target.className.indexOf('player-slider-bar-ball') !== -1) {
        //         e.target.className += ' player-slider-bar-ball-focus';
        //         console.log('[NPC2] Playercontrols onFocus slider ball ', e.target.className);
        //     }
        // }
    }

    onUnfocus(e) {
        if (e.target.className.indexOf('video-player-control-button') !== -1) {
            const idn = +e.target.id.substring(2);
            const titlesb = Array.from(document.querySelectorAll('.video-player-control-button-title'));
            titlesb && Array.isArray(titlesb) && titlesb.length > 0 && titlesb.forEach((bt, idx) => {
                if (idx === idn) {
                    bt.classList.remove('player-controls-vod-title-empha');
                }
            });
            // e.target.style.height = `${videoControlHeight}px`;
            // e.target.style.width = `${videoControlWidth}px`;
        }
        // else {
        //     if (e.target.className.indexOf('player-slider-bar-ball') !== -1) {
        //         console.log('[NPC2] Playercontrols onUnfocus slider ball');
        //         e.target.className = e.target.className.replace(' player-slider-bar-ball-focus', '');
        //     }
        // }
    }

    closeModal(modalType) {
        if (!Utils.isModalHide() && modalType === Utils.modalType()) {
            store.dispatch({
                type: HIDE_MODAL,
                modalType
            });
        }
    }

    reloadRecordings = () => {
        console.log("::: reloadRecordings");
        this.props && (typeof this.props.sendMetric === 'function') && this.props.sendMetric('mis contenidos', 'grabando');
        let urlMyContent = false;
        if (Utils.getLinks()) {
            const urls = Utils.getLinks();
            urlMyContent = urls && urls.miscontenidos && `/node/${urls.miscontenidos}`;
        }
        if (!urlMyContent) return;
        (typeof this.props.stopPlayer === 'function') && this.props.stopPlayer();
        this.history && this.history.push && (typeof this.history.push === 'function') && this.history.push(urlMyContent);
    }

    backHandler = () => {
        if (this.state.visible || this.state.miniEpgVisible) {
            if (this.state.visible) {
                if (this.shouldHideSkipIntro()) {
                    this.hideSkipIntro();
                }
            }

            if (this.state.miniEpgVisible) this.hideMini();
            if (this.state.visible) this.hide();
        }
        else {
            if (this.state.skipIntroVisible) {
                this.hideSkipIntro();

                return;
            }

            if(this.state.contentStreamType === AAF_CONTENT_IS_NPVR)LayersControl.showUX()
                Utils.isCurrentNode('miscontenidos', this.history) && this.reloadRecordings();

            this.back();
        }
    }

    hideMiniEpgWithVisibilityValidation() {
        if (this.state.miniEpgVisible) {
            this.hideMini();
        }
    }

    fireTPAApp() {
        let nextOptions = {};
        if(Utils.isFunction(this.props.getCurrentPlayerOptions)) {
            nextOptions = this.props.getCurrentPlayerOptions();
        }
        const TPA = nextOptions.isTPA;

        console.log('[TPA] PlayerControls::fireTPAApp enter...le lanzará TPA: ', TPA);
        console.log('[TPA] PlayerControls::fireTPAApp se manda STOP');

        // Nota: Se excluye la función stopPlayer para dejar el mismo comportamiento de la aplicación antes de ejecutar la TPA
        // if(Utils.isFunction(this.props.stopPlayer)) {
        //     this.props.stopPlayer();
        // }

        // Notificar que se lanzará una nueva app
        if(Utils.isFunction(this.props.onFireTPA)) {
          console.log('[TPA] PlayerControls::fireTPAApp se lanza notificación onFireTPA');
          this.props.onFireTPA(TPA, nextOptions);
        }

        ThirdPartyEpgHelper.fireTPA(TPA, nextOptions, this.fireTPAAppResult);

        return true;
      }

      fireTPAAppResult(TPA, playerOptions, result) {
        if(!Utils.isBoolean(result)) {
          if(Utils.isString(result)) {
            result === 'true' ? true : false;
          }
        }

        if(!result) {
          if(Utils.isFunction(this.callbacks.onResultFireTPA)) {
            this.props.onResultFireTPA(TPA, playerOptions, result);
          }
        }
      }

    keyPressHandler(e) {
        console.log('[NPC] PlayerControls attemp to keyPressHandler');
        if (!Utils.isModalHide()) {
            return;
        }

        if (!Utils.isNotificationHide() && Utils.modalType() !== MODAL_INACTIVITY) {
            return;
        }

        if (Utils.isFullEpgPersistanceOpen()) {
            return;
        }

        if (LayersControl.isUXVisible()) return;

        const modal = document.getElementsByClassName('modal-overlay');
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        console.log('[NPC] PlayerControls keyPressHandler', currentKey);

        let isLiveFlavour = null, isVODFlavour = null, enableChangeChannelUpdown = false;

        switch (currentKey) {
            case 'INFO':
                e.preventDefault();
                e.stopPropagation();
                switch (this.state.contentStreamType) {
                    case AAF_CONTENT_IS_TV:
                        if (this.state.visible) {
                            this.hide();
                        }
                        else {
                            if(this.isTPA(this.props.groupId)) {
                                this.state.miniEpgVisible && this.hideMini();
                            }
                            else {
                                this.state.miniEpgVisible ? this.hideMini() : this.showMini();
                            }
                        }
                        break;
                    case AAF_CONTENT_IS_CATCHUP:
                        if (this.state.visible) {
                            this.hide();
                        }
                        else {
                            this.state.miniEpgVisible ? this.hideMini() : this.showMini();
                        }
                        break;
                    case AAF_CONTENT_IS_STARTOVER:
                        if (this.state.miniEpgVisible) {
                            this.hideMini();
                        }
                        else {
                            this.state.visible ? this.hide() : this.show();
                        }
                        break;
                    case AAF_CONTENT_IS_NPVR:
                    case AAF_CONTENT_IS_VOD:
                        this.state.visible ? this.hide() : this.show();
                        break;
                    default:
                        break;
                }
                break;
            // TODO ajustar fwd y next_skip para vod
            case 'FWD':
            case 'NEXT_SKIP':
                e.preventDefault();
                e.stopPropagation();

                // si no video, nada que hacer
                if (!this.canPlay) return;

                switch (this.state.contentStreamType) {
                    case AAF_CONTENT_IS_TV:
                        if (this.state.miniEpgVisible) {
                            this.hideMini();
                        }
                        store.dispatch(showFunctionNotAvailableNotification());
                        break;
                    case AAF_CONTENT_IS_STARTOVER:
                    case AAF_CONTENT_IS_CATCHUP:
                    case AAF_CONTENT_IS_NPVR:
                        // Hide mini
                        if (this.state.contentStreamType === AAF_CONTENT_IS_CATCHUP || this.state.contentStreamType === AAF_CONTENT_IS_NPVR) {
                            this.closeModal(MODAL_LANGUAGES);
                        }
                        if (this.state.miniEpgVisible) {
                            this.hideMini();
                        }
                        // Show PC
                        this.show();

                        // ANTES:
                        //  Startover y catchup sobre el RCU hacen un "seek normal"
                        //  Startover y catchup sobre el controles de PC hacen trickmode
                        // AHORA:
                        //  Startover y catchup haran trickmode en RCU y en controls del player
                        if (EventTimeshift.isTrickModeEnabled()) {
                            this.refs.playerControls.speedBackward && this.refs.playerControls.speedForward();
                        }
                        else {
                            this.refs.playerControls.backward && this.refs.playerControls.forward();
                        }
                        break;
                    case AAF_CONTENT_IS_VOD:
                        this.closeModal(MODAL_LANGUAGES);
                        // Show PC
                        this.show();
                        if (this.refs.playerControls && this.refs.playerControls.forward) {
                            this.refs.playerControls.forward();
                        }
                        break;
                    default:
                        break;
                }
                break;
            // TODO ajustar rwd y prev_skip para vod
            case 'RWD':
            case 'PREV_SKIP':
                e.preventDefault();
                e.stopPropagation();

                // si no video, nada que hacer
                if (!this.canPlay) return;

                switch (this.state.contentStreamType) {
                    case AAF_CONTENT_IS_TV:
                        if (this.state.timeshiftEventInfo) {
                            if (this.state.miniEpgVisible) {
                                this.hideMini();
                            }

                            if(!this.isTPA(this.props.groupId)) {
                                // Show PC
                                this.show();
                            }

                            if (this.refs.playerControls && this.refs.playerControls.backward) {
                                this.refs.playerControls.backward();
                            }
                        }
                        else {
                            store.dispatch(showFunctionNotAvailableNotification());
                        }
                        break;
                    case AAF_CONTENT_IS_STARTOVER:
                    case AAF_CONTENT_IS_CATCHUP:
                    case AAF_CONTENT_IS_NPVR:
                        // Hide mini
                        if (this.state.contentStreamType === AAF_CONTENT_IS_CATCHUP || this.state.contentStreamType === AAF_CONTENT_IS_NPVR) {
                            this.closeModal(MODAL_LANGUAGES);
                        }
                        if (this.state.miniEpgVisible) {
                            this.hideMini();
                        }
                        // Show PC
                        this.show();
                        if (this.refs.playerControls) {
                            // ANTES:
                            //  Startover y catchup sobre el RCU hacen un "seek normal"
                            //  Startover y catchup sobre el controles de PC hacen trickmode
                            // AHORA:
                            //  Startover y catchup haran trickmode en RCU y en controls del player
                            if (EventTimeshift.isTrickModeEnabled()) {
                                this.refs.playerControls.speedBackward && this.refs.playerControls.speedBackward();
                            }
                            else {
                                this.refs.playerControls.backward && this.refs.playerControls.backward();
                            }
                        }
                        break;
                    case AAF_CONTENT_IS_VOD:
                        this.closeModal(MODAL_LANGUAGES);
                        // Show PC
                        this.show();
                        if (this.refs.playerControls && this.refs.playerControls.backward) {
                            this.refs.playerControls.backward();
                        }
                        break;
                    default:
                        break;
                }
                break;
            case 'PLAYPAUSE':
            case 'PAUSE':
            case 'PLAY':
                e.preventDefault();
                e.stopPropagation();

                // si no video, nada que hacer
                if (!this.canPlay) return;

                switch (this.state.contentStreamType) {
                    case AAF_CONTENT_IS_TV:
                        if (this.state.timeshiftEventInfo) {
                            if (this.state.miniEpgVisible) {
                                this.hideMini();
                            }

                            if(!this.isTPA(this.props.groupId)) {
                                // Show PC
                                this.show();
                            }

                            // Está en pause o en play?
                            if (this.state.playing) {
                                console.log('WHENPAUSE entra en listener, esta en play y entrara a pausa');
                                if (this.refs.playerControls && this.refs.playerControls.pause) {
                                    this.canPlay && this.refs.playerControls.pause();
                                }
                            }
                            else {
                                console.log('WHENPAUSE entra en listener, esta en pausa entrara en play');
                                if (this.refs.playerControls && this.refs.playerControls.play) {
                                    this.canPlay && this.refs.playerControls.play();
                                }
                            }
                        }
                        break;
                    case AAF_CONTENT_IS_STARTOVER:
                    case AAF_CONTENT_IS_CATCHUP:
                        if (this.state.miniEpgVisible) {
                            this.hideMini();
                        }

                        // Show PC
                        this.show();

                        // Está en pause o en play?
                        if (this.state.playing) {
                            if (this.refs.playerControls && this.refs.playerControls.pause) {
                                this.refs.playerControls.pause();
                            }
                        }
                        else {
                            if (this.refs.playerControls && this.refs.playerControls.play) {
                                this.refs.playerControls.play();
                            }
                        }
                        break;
                    case AAF_CONTENT_IS_NPVR:
                    case AAF_CONTENT_IS_VOD:
                        // Show PC
                        this.show();

                        // Está en pause o en play?
                        if (this.state.playing) {
                            if (this.refs.playerControls && this.refs.playerControls.pause) {
                                this.refs.playerControls.pause();
                            }
                        }
                        else {
                            if (this.refs.playerControls && this.refs.playerControls.play) {
                                this.refs.playerControls.play();
                            }
                        }
                        break;
                    default:
                        break;
                }
                break;
            case 'STOP':
                e.preventDefault();
                e.stopPropagation();
                // No importa si canPlay = true/false, hacemos back porque
                // queremos hacer back
                switch (this.state.contentStreamType) {
                    // Sólo para VOD flavours
                    case AAF_CONTENT_IS_CATCHUP:
                    case AAF_CONTENT_IS_NPVR:
                    case AAF_CONTENT_IS_VOD:
                        this.closeModal(MODAL_LANGUAGES);
                        if (this.state.miniEpgVisible) this.hideMini();
                        if (this.state.visible) this.hide();
                        if (this.state.skipIntroVisible) this.hideSkipIntro();
                        this.back();
                        break;
                    default:
                        break;
                }
                break;
            case 'REC':
                e.preventDefault();
                e.stopPropagation();

                //Si esta abierta la mini se ignora este REC, si no se toma el evento actual
                if (Utils.isMiniEpgPersistanceOpen()) return;
                switch (this.state.contentStreamType) {
                    case AAF_CONTENT_IS_TV:
                    case AAF_CONTENT_IS_CATCHUP:
                    case AAF_CONTENT_IS_STARTOVER:
                        //estas funciones se ejecutan tambien en onRecording
                        // if (this.state.visible) this.hide();
                        // if (this.state.miniEpgVisible) this.hideMini();
                        if (this.state.skipIntroVisible) this.hideSkipIntro();

                        if(!this.isTPA(this.props.groupId)) {
                            this.onRecording(e, true);
                        }
                        break;
                    default:
                        break;
                }
                break;
            case 'SUB_AUD': // SUBTITLES
                e.preventDefault();
                e.stopPropagation();

                if (!this.canPlay) return;

                switch (this.state.contentStreamType) {
                    case AAF_CONTENT_IS_TV:
                        if (this.state.visible) this.hide();
                        if (this.state.miniEpgVisible) this.hideMini();
                        if (this.state.skipIntroVisible) this.hideSkipIntro();

                        if(!this.isTPA(this.props.groupId)) {
                            this.onShowLanguages();
                        }
                        break;
                    case AAF_CONTENT_IS_CATCHUP:
                    case AAF_CONTENT_IS_STARTOVER:
                    case AAF_CONTENT_IS_NPVR:
                        if (this.state.timeshiftEventInfo) {
                            if (this.state.visible) this.hide();
                            if (this.state.miniEpgVisible) this.hideMini();
                            if (this.state.skipIntroVisible) this.hideSkipIntro();
                            this.onShowLanguages();
                        }
                        break;
                    case AAF_CONTENT_IS_VOD:
                        if (this.state.visible) this.hide();
                        if (this.state.miniEpgVisible) this.hideMini();
                        this.onShowLanguages();
                        break;
                    default:
                        break;
                }
                break;
            case 'MOSAIC':
                e.preventDefault();
                e.stopPropagation();

                if (this.state.visible) this.hide();
                if (this.state.miniEpgVisible) this.hideMini();

                switch (this.state.contentStreamType) {
                    case AAF_CONTENT_IS_TV:
                    case AAF_CONTENT_IS_CATCHUP:
                    case AAF_CONTENT_IS_STARTOVER:
                        ModalEpgUtils.showGridChannels({
                            isFromKey: true,
                            handleGuideCb: this.onToggleEpg
                        });
                        break;
                    default:
                        break;
                }
                break;
            case 'OK':
                const tgt = e.target && e.target.className && e.target.className;

                const className = 'aaf_colored-button';
                const children = e.target.children || [];
                const firstChild = Array.isArray(children) ? children[0] : null;
                const isClassinChild = (firstChild && (firstChild.className.includes(className) || firstChild.className.includes('ihelper')));
                if (tgt.indexOf(className) !== -1 || isClassinChild) {
                    return
                };
                if (tgt.indexOf('skip-intro-button') !== -1) {
                    console.log('[SKIP] return en key handler OK');
                    return;
                }
                if (Utils.isSamsungOrsay() && tgt && typeof tgt === 'string' && tgt.includes('video-player-control-button')) {
                    console.log('[SKIP stopPropagation] on OK key');
                    return;
                }
                e.preventDefault();
                e.stopPropagation();

                if (this.state.contentStreamType === AAF_CONTENT_IS_VOD) {
                    this.playerControlsActivityNotifier.sendActivity(new PlayerControlsActivity(RESET_AUTOHIDE_VOD_PLAYER_CONTROLS_EVENT, {}));
                }

                if (this.state.contentStreamType === AAF_CONTENT_IS_TV) {
                    if(this.props.groupId && this.isTPA(this.props.groupId)) {
                        this.fireTPAApp();
                        return;
                    }
                }

                if (this.state.visible || this.state.miniEpgVisible) return;
                this.managePlayerControls(e, currentKey);
                break;
            case 'BACK':
                e.preventDefault();
                e.stopPropagation();
                this.backHandler();
                break;
            case 'RIGHT':
            case 'LEFT':
            case 'UP':
            case 'DOWN':
                if (this.state.contentStreamType === AAF_CONTENT_IS_VOD) {
                    this.playerControlsActivityNotifier.sendActivity(new PlayerControlsActivity(RESET_AUTOHIDE_VOD_PLAYER_CONTROLS_EVENT, {}));
                }
                this.managePlayerControls(e, currentKey);
                break;
            case 'ZERO':
            case 'ONE':
            case 'TWO':
            case 'THREE':
            case 'FOUR':
            case 'FIVE':
            case 'SIX':
            case 'SEVEN':
            case 'EIGHT':
            case 'NINE':
                this.resetAutoHideTimer();
                // Se agrega feature: se permite el cambio numérico en catchup
                const canUseNumericPad = this.state.contentStreamType === AAF_CONTENT_IS_TV
                    || this.state.contentStreamType === AAF_CONTENT_IS_STARTOVER
                    || this.state.contentStreamType === AAF_CONTENT_IS_CATCHUP;
                if (canUseNumericPad && modal.length === 0) {
                    if (!this.props.isChangingChannel() && !this.props.checkStatusEPG) {
                        this.handleChannelChange(e, this.codeToVal.getKeyValue(currentKey));
                    }
                }
                break;
            case 'GUIDE':
                e.preventDefault();
                e.stopPropagation();
                if (this.props.isChangingChannel()) {
                    return;
                }
                if (this.state.miniEpgVisible) this.hideMini();
                if (this.state.visible) this.hide();
                if (this.state.skipIntroVisible) this.hideSkipIntro();

                isLiveFlavour = this.state.contentStreamType === AAF_CONTENT_IS_TV || this.state.contentStreamType === AAF_CONTENT_IS_STARTOVER || this.state.contentStreamType === AAF_CONTENT_IS_CATCHUP;
                isVODFlavour = this.state.contentStreamType === AAF_CONTENT_IS_VOD || this.state.contentStreamType === AAF_CONTENT_IS_NPVR;
                if (isLiveFlavour) {
                    this.props.handleFullEpg('GUIDE');
                }
                break;
            /**
             * Para cambio de canal con el RCU, mini persistente cambia canal
             * y PC controla si se muestra o no la mini
             * El key event llega primero a mini, luego el evento llega aquí para mostrar o
             * no la mini
             * */
            case 'CH_UP':
            case 'CH_DOWN':
                if(Utils.modalType() === MODAL_INACTIVITY){
                  e.preventDefault();
                    e.stopPropagation();
                  return;
                }
                enableChangeChannelUpdown = this.state.contentStreamType === AAF_CONTENT_IS_TV
                    || this.state.contentStreamType === AAF_CONTENT_IS_STARTOVER
                    || this.state.contentStreamType === AAF_CONTENT_IS_CATCHUP;
                if (!enableChangeChannelUpdown) {
                    e.preventDefault();
                    e.stopPropagation();
                    break;
                }

                if (this.state.visible) {
                    this.hide();
                }

                if (Utils.choiceBehaviorChannelChange()) {
                    if (!this.state.miniEpgVisible) {
                        if (this.props.isChangingChannel()) {
                            break;
                        }
                        if (modal.length === 0) {
                            this.showMini();
                        }
                    }
                }
                // El stop antes se hacía en la mini, ahora la mini sólo se encarga de
                // cambiar el canal al que quiere el user
                // Y aquí PC se encarga de mostrar o no la mini
                e.preventDefault();
                e.stopPropagation();
                break;
            /**
             * MANAGE RCU colors when apply
             *
             * GREEN managed 100% here (at this moment, some day of feb-2021, covid epoch)
             */
            case GREEN_BUTTON:
                if (!Utils.isNotificationHide()) {
                    return;
                }

                const isActiveSearch = document.getElementsByClassName('search');
                    if (isActiveSearch && isActiveSearch[1] !== undefined) {
                    ClearTextSearch.fire();
                }

                e.preventDefault();
                e.stopPropagation();

                switch (this.state.contentStreamType) {
                    case AAF_CONTENT_IS_VOD:
                    case AAF_CONTENT_IS_NPVR:
                        if (this.state.miniEpgVisible) this.hideMini();
                        if (this.state.visible) this.hide();
                        if (this.state.skipIntroVisible) this.hideSkipIntro();
                    break;
                    default:
                        this.manageGreenButton();
                    break;
                }
                break;
            /**
             * El botón BLUE se controla en la mini persistente una parte
             * pero el evento llega hasta acá y aquí sólo se cierra
             * la mini y/o PC según aplique
             */
            case BLUE_BUTTON:
                if (!Utils.isNotificationHide()) {
                    return;
                }
                e.preventDefault();
                e.stopPropagation();
                this.manageBlueButton(false);
                break;
            /**
             * Red button se maneja completo ahora aquí antes
             * era una parte en la mini persistente
             */
            case RED_BUTTON:
                if (!Utils.isNotificationHide()) {
                    return;
                }
                e.preventDefault();
                e.stopPropagation();
                this.manageRedButton();
                break;
            case YELLOW_BUTTON:
                if (!Utils.isNotificationHide()) {
                    return;
                }
                e.preventDefault();
                e.stopPropagation();
                this.manageYellowButton();
                break;
            default:
                break;
        }
    }

    handleChannelChange(e, number) {
        e.preventDefault();
        e.stopPropagation();

        if (this.props.isChangingChannel()) {
            return;
        }

        if (this.state.contentStreamType === AAF_CONTENT_IS_TV) {
            if(!this.isTPA(this.props.groupId)) {
                // se muestra la mini
                if (this.state.visible) this.hide();
                if (!this.state.miniEpgVisible) this.showMini();
            }
        }
        else if (this.state.contentStreamType === AAF_CONTENT_IS_STARTOVER) {
            if (this.state.miniEpgVisible) this.hideMini();
            if (!this.state.visible) this.show();
        }
        else {
            if (this.state.miniEpgVisible) this.hideMini();
            if (this.state.visible) this.hide();
        }

        if (this.timerDelayChannelChange) clearTimeout(this.timerDelayChannelChange);
        this.lastNumberPressed = `${this.lastNumberPressed}${number}`;
        const currentLength = this.lastNumberPressed.length;

        if (
            this.refs.channelNumber &&
            currentLength <= this.maxLenNumberChannel
        ) {
            this.refs.channelNumber.innerHTML = this.lastNumberPressed;
            this.refs.channelNumber.className = 'player-controls-channel-number';
        }

        this.timerDelayChannelChange = setTimeout(() => {
            this.channelChangeHandler(this.lastNumberPressed, this.props.linealChannels);
        }, this.delayChannelChange);
    }

    channelChangeHandler(newChannel) {
        /**
         * Numeric channel change RCU, parse number channel to compare
         * '10' == '10' and not '010' == '10'
         */
        if (newChannel.length > 0) {
            if (newChannel.substring(0, 1) == '0') {
                newChannel = Number.parseInt(newChannel);
            }
        }

        if (this.state.contentStreamType === AAF_CONTENT_IS_STARTOVER) {
            if (this.state.miniEpgVisible) this.hideMini();
            if (this.state.visible) this.hide();
        }

        this.timerDelayChannelChange = null;
        new ChannelSingleton().getChannels().then(channels => {
            let channelIndex = channels.findIndex(channel => channel.id == newChannel);
            const channel =
                channelIndex >= 0
                    ? channels[channelIndex]
                    : Utils.getClosestChannel(parseInt(newChannel), channels);

            if (channel) {
                if (channel.group_id !== TvChannelUtil.getLastChannel()) {
                    let channelIndex = channels.findIndex(channel => channel.id == newChannel);
                    let paywayTem = this.props.linealChannels.map(x => x.id);
                    let paywayIds = channels
                        .filter(x => paywayTem.indexOf(x.group_id) != -1)
                        .map(x => x.group_id);
                    if (channelIndex >= 0) {
                        if (paywayIds.indexOf(channels[channelIndex].group_id) == -1) {
                            this.refs.channelNumber.innerHTML = '';
                            this.refs.channelNumber.className = '';
                            this.resetChannelNumberId = null;
                            this.lastNumberPressed = '';
                            this.playerStreamingUtils.checkSusc(null, channel.group_id);
                            return;
                        } else {
                            this.props.hideOnlyMini(
                                paywayIds.indexOf(channels[channelIndex].group_id)
                            );
                        }
                    } else {
                        channels = channels.filter(x => paywayIds.indexOf(x.group_id) > -1);
                        const channel = Utils.getClosestChannel(parseInt(newChannel), channels);
                        this.props.hideOnlyMini(paywayIds.indexOf(channel.group_id));
                    }
                }
                if (this.refs.channelNumber) {
                    this.refs.channelNumber.innerHTML = this.lastNumberPressed;
                    this.resetChannelNumberId = setTimeout(() => {
                        this.refs.channelNumber.innerHTML = '';
                        this.refs.channelNumber.className = '';
                        this.resetChannelNumberId = null;
                        this.lastNumberPressed = '';
                    }, this.delayChannelChange / 2);
                }
            }
        });
    }

    /**
     * TODO se deja por compatibilidad, pero eliminarla después
     */
    setTimer() {
    }

    workflowInBack () {
      // Se cerrará  player
      // Se resetea state
      if (Utils.isTimeoutAvailable()) {
        const { clearTimeOutAAF = () => { } } = this.props;
        clearTimeOutAAF();
      }
      this.setState({
          playing: false,
          timeshiftEventInfo: null,
          normalEventInfo: null,
          contentStreamType: null,
          channelInfo: null
      }, () => {
          this.duration = 0;
          this.currentTime = 0;
          this.canPlay = false;
          this.currentEvent = null;
          this.props.back(false);
      });
    }

    back() {
        const contentStreamType = this.state.contentStreamType;
        this.stopAutoHideTimer();
        if (this.state.miniEpgVisible) this.hideMini();
        if (this.state.visible) this.hide();

        let category = 'reproductor tv';

        if (contentStreamType === AAF_CONTENT_IS_STARTOVER) {
          FallbackUtil.clearFallback();
          Utils.modalType() !== MODAL_INACTIVITY ? this.props.goToLive(this.setTimer) : this.workflowInBack()
        }
        else {
            switch (contentStreamType) {
                case AAF_CONTENT_IS_CATCHUP:
                case AAF_CONTENT_IS_VOD:
                case AAF_CONTENT_IS_NPVR:
                case AAF_CONTENT_IS_TV:
                    // Se cerrará  player
                    // Se resetea state
                    this.workflowInBack()
                    break;
                default:
                    // TODO checar bandea false
                    this.props.back(false);
                    break;
            }

            switch (contentStreamType) {
                case AAF_CONTENT_IS_VOD:
                case AAF_CONTENT_IS_NPVR:
                    category = 'reproductor';
                    break;
                default:
                    break;
            }

            PlayerControlsLogic.sendMetric('click', 'salir', this.props.dataMetric, this.props.setMetricsEvent, false, this.getCurrentTimeInMinutes(), this.getDurationInMinutes(), category);
        }
    }

    isStartOverWithTimeshiftEvent() {
    }

    useTimeshiftEvent() {
    }

    isVisible() {
        return this.state.visible || this.state.miniEpgVisible;
    }

    /**
   * Manage player controls,
   * player controls could be:
   *  player controls
   *  mini epg mazapan
   *  full epg
   *
   * What to show when user press up, down, right, left arrows?
   * here is the place to try to manage that
   */
    managePlayerControls(e, currentKey) {

        if (this.props.isChangingChannel()) {
            return;
        }

        const modal = document.getElementsByClassName('modal-overlay');

        if (modal.length === 0) {
            if (!this.isVisible()) {
                e.preventDefault();
                e.stopPropagation();

                const currentContentType = this.state.contentStreamType;

                switch (currentContentType) {
                    case AAF_CONTENT_IS_TV:
                        if(!this.isTPA(this.props.groupId)) {
                            this.showMini();
                        }
                    break;
                    case AAF_CONTENT_IS_CATCHUP:
                    case AAF_CONTENT_IS_STARTOVER:
                        this.showMini();
                        break;
                    case AAF_CONTENT_IS_NPVR:
                    case AAF_CONTENT_IS_VOD:
                        this.show();
                        // To avoid click on play pause button when player controls are showed
                        window.SpatialNavigation.pause();
                        // Focus play/pause button
                        setTimeout(() => {
                            window.SpatialNavigation.resume();
                            if (this.state.hasSkipIntro && this.state.skipIntroVisible && this.state.justWasSkipIntroClosedFirstTime) {
                                this.focus('.skip-intro-button');
                            }
                            else {
                                this.focus(this.state.playing ? '.video-player-control-main-button-pause' : '.video-player-control-main-button-play');
                            }
                        }, 300);
                        break;
                    default:
                        break;
                }
            }
            else {
                // es Timeshift y esta en pausa?
                const tsInPause = this.isContentTSInPause();
                const { target: { id = null } = {} } = e;
                if (currentKey === 'UP' && id === 'player-ui-progress-bar-ball') {
                    console.log('WHENPAUSE PC es visible es UP ');
                    e.preventDefault();
                    e.stopPropagation();
                    if(tsInPause) {
                        console.log('WHENPAUSE PC es visible y es TS, se para el timer, se deja visible pc ');
                        this.stopAutoHideTimer();
                    }
                    else {
                        if (this.state.visible) this.hide();
                    }
                }
                else {
                    if(tsInPause) {
                        console.log('WHENPAUSE reset timer, es ts en pausa, se deja visible pc');
                        this.stopAutoHideTimer();
                    }
                    else {
                        // Se alarga el autohide
                        console.log('WHENPAUSE reset timer, se ocultará.....con flechas',);
                        this.resetAutoHideTimer();
                    }
                }
            }
        }
    }

    isContentTSInPause() {
        let isTs = false;
        switch (this.state.contentStreamType) {
            case AAF_CONTENT_IS_CATCHUP:
            case AAF_CONTENT_IS_STARTOVER:
            case AAF_CONTENT_IS_NPVR:
                isTs = true; // en este punto no es necesario validar si es ts, si llegamos aquí ya es ts
            break;
            case AAF_CONTENT_IS_TV:
                isTs = this.isLiveWithTimeshift();
            break;
            default:
            break;
        }

        // Regresa true solo si es TS y pc esta visible y esta en pausa
        return isTs && this.state.visible && !this.state.playing;
    }

    componentWillUnmount() {
        console.log('[NPC] DM PlayerControls nuevo componentWillUnmount');
        this.disableFocus();
        this.removeEventListeners();
        this.duration = 0;
        this.currentTime = 0;
        this.canPlay = false;
        this.stopAutoHideTimer();
        this.currentLangChapter = [];
        RecordingsNotification.unsubscribe(this.handleRecordingsNotification);
    }

    focus(selector) {
        if (Utils.isModalHide()) {
            return window.SpatialNavigation.focus(selector);
        }
    }

    onSelectEpisodes(group_id = null, title = '') {
        this.hide();
        if (this.state.skipIntroVisible) this.hideSkipIntro();
        const { history = null } = this.props;

        PlayerControlsLogic.sendMetric('control player', 'episodios', this.props.dataMetric, this.props.setMetricsEvent, false, this.getCurrentTimeInMinutes(), this.getDurationInMinutes(), 'reproductor');
        const modalProps = {
          data: this.state.serieData,
          group_id,
          title,
          history,
          changeContentfromSelector: this.props && this.props.changeContentfromSelector || null
        };

        setValuesStoreModalKeepWatching({ modalPropsOptionsEpisodes: modalProps });


        const modal = {
            modalType: MODAL_OPTIONS_EPISODES,
            modalProps,
        };

        store.dispatch(showModal(modal));
    }

    toggleVisible() {
        this.setState({
            visible: !this.state.visible
        });
    }

    // Flavours, método engañoso o_O
    // ojo al usarlo
    isLive() {
        switch (this.state.contentStreamType) {
            case AAF_CONTENT_IS_CATCHUP:
            case AAF_CONTENT_IS_NPVR:
            case AAF_CONTENT_IS_VOD:
                return false;
            case AAF_CONTENT_IS_TV:
            case AAF_CONTENT_IS_STARTOVER:
                return true;
                break;
            default:
                break;
        }
    }

    /**
     * Método para mostrar SÓLO PlayerControls (No controla la mini)
     */
    show() {
        console.log('[SKI] enter show()');

        // Antes:
        //  Autohide funciona en todo
        // Después
        //  Autohide no aplica en startover, catchup, npvr en pausa y trick mode
        switch(this.state.contentStreamType) {
            case AAF_CONTENT_IS_STARTOVER:
            case AAF_CONTENT_IS_CATCHUP:
            case AAF_CONTENT_IS_NPVR:
                // Si esta en trick mode se para el timer ∫
                if((this.refs.playerControls && this.refs.playerControls.isInTrickMode) ||
                    !this.state.playing) {
                    console.log('WHENPAUSE show() sólo se hace stop del timer, esta en trick o en pause');
                    this.stopAutoHideTimer();
                }
                else {
                    console.log('WHENPAUSE show() se hace el interval del autohide');
                    this.resetAutoHideTimer();
                }
            break;
            default:
                // Si esta en pausa, si es en vivo y es en vivo con ts
                // entonces no se oculta el player controls, sólo se
                // muestra y ahí se queda
                if(!this.state.playing
                    && this.state.contentStreamType === AAF_CONTENT_IS_TV
                    && this.isLiveWithTimeshift()) {
                        console.log('WHENPAUSE show() sólo se hace stop del timer, esta en trick o en pause y es TV vivo con ts');
                        this.stopAutoHideTimer();
                }
                else {
                    this.resetAutoHideTimer();
                }
            break;
        }

        // Nada que hacer si el otro player controls tiene el control
        // (para controlar observers)
        if (!this.enabledForThisContentStreamType()) return;

        // TODO cuando se lanza playercontrols hay que hacer foco en play button
        console.log('[NPC] try show, this.state.visible: ', this.state.visible);
        this.enableFocus();
        this.enableFocus(COLOREDBAR_FOCUS_ZONE_PLAYERCONTROLS);

        const className = this.refs.playerControlsContainer.className;
        if (className.indexOf('player-controls-hide') > -1) {
            this.refs.playerControlsContainer.className = this.refs.playerControlsContainer.className.replace('player-controls-hide', '');
        }

        this.props.controlBarIsShowed(true);

        if (this.state.visible) return;

        this.setState({ visible: true }, () => {
            this.animateColoredBar('coloredBarControls');
            this.managePlayerControlsSkipIntroFocus();
            if (this.shouldShowSkipIntro()) {
                this.showSkipIntro(true);
                setTimeout(() => {
                    this.focus('.skip-intro-button');
                }, 300);
            }
            else {
                if (this.state.contentStreamType === AAF_CONTENT_IS_TV && !this.isLiveWithTimeshift()) {
                    setTimeout(() => {
                        this.focus('.video-player-control-main-button');
                    }, 300);
                }
                else {
                    setTimeout(() => {
                        this.focus(this.state.playing ? '.video-player-control-main-button-pause' : '.video-player-control-main-button-play');
                    }, 300);
                }
            }
        });
    }

    animateColoredBar(what) {
        if (!this.settings_animateColoredBar.enable) {
            this.animateColoredBarSimulated(what);
            return;
        }
        if (!window.requestAnimationFrame) {
            this.animateColoredBarSimulated(what);
            return;
        }

        if (this.settings_animateColoredBar.animatedIntervalID) window.cancelAnimationFrame(this.settings_animateColoredBar.animatedIntervalID);

        const coloredBar = this.refs[what] || null;
        if (!coloredBar) return;

        let start = null;
        const byStep = (timestamp) => {
            if (start === null) {
                start = 0;
            }
            start += this.settings_animateColoredBar.animatedIntervalStep;
            let stepX = Math.min(start, (this.settings_animateColoredBar.animatedIntervalLowPos * -1));
            stepX = stepX * -1;
            coloredBar.style.transform = 'translateY(' + stepX + 'px)';

            if (start < (this.settings_animateColoredBar.animatedIntervalLowPos * -1)) {
                this.settings_animateColoredBar.animatedIntervalID = window.requestAnimationFrame(byStep);
            }
        }

        this.settings_animateColoredBar.animatedIntervalID = window.requestAnimationFrame(byStep);
    }

    /**
     * Animate colored bar controls
     */
    animateColoredBarSimulated(what) {
        if (this.settings_animateColoredBar.animatedIntervalID) clearInterval(this.settings_animateColoredBar.animatedIntervalID);
        const coloredBar = this.refs[what] || null;

        if (coloredBar) {
            if (this.settings_animateColoredBar.enable) {
                let posIn = this.settings_animateColoredBar.animatedIntervalLowPos;

                this.settings_animateColoredBar.animatedIntervalID = setInterval(() => {
                    posIn = posIn + this.settings_animateColoredBar.animatedIntervalStepSimulated;
                    if (posIn >= this.settings_animateColoredBar.animatedIntervalHightPos) {
                        clearInterval(this.settings_animateColoredBar.animatedIntervalID);
                    }
                    coloredBar.style.bottom = `${posIn}px`;
                }, this.settings_animateColoredBar.animatedIntervalMS);
            }
            else {
                coloredBar.style.bottom = this.settings_animateColoredBar.animatedIntervalHightPos;
            }
        }
    }

    resetAnimateColoredBar(what) {
        if (!this.settings_animateColoredBar.enable) {
            this.resetAnimateColoredBarSimulated(what);
            return;
        }

        if (!window.requestAnimationFrame) {
            this.resetAnimateColoredBarSimulated(what);
            return;
        }

        const coloredBar = this.refs[what] || null;
        if (!coloredBar) return;
        coloredBar.style.transform = 'translateY(0)';
    }

    resetAnimateColoredBarSimulated(what) {
        if (this.settings_animateColoredBar.animatedIntervalID) clearTimeout(this.settings_animateColoredBar.animatedIntervalID);
        const coloredBar = this.refs[what] || null;
        if (coloredBar) {
            if (this.settings_animateColoredBar.enable) {
                coloredBar.style.bottom = `${this.settings_animateColoredBar.animatedIntervalLowPos}px`;
            }
            else {
                coloredBar.style.bottom = `${this.settings_animateColoredBar.animatedIntervalHightPos}px`;
            }
        }
    }

    showMini() {
        const { show: showNotification = false} = store.getState().notification.notificationProps;

        if(showNotification) return; // No se muestra mini si hay notificación

        this.resetAutoHideTimer();
        // Nada que hacer si el otro player controls tiene el control
        // (para controlar observers)
        if (!this.enabledForThisContentStreamType()) return;
        if (!this.refs.miniEpgContainer) return;

        if (this.props.checkStatusEPG) return;
        console.log('[NPC] try show Mini,');
        /**
         * Por el momento se deshabilita foco la colored bar
         * para que spatial no intente buscarla y nos genere
         * issues al momento de navegar la mini.
         *
         * Hasta que nos definan cómo es focuseable la colored y la mini
         */
        this.disableFocus(COLOREDBAR_FOCUS_ZONE_MINIEPG);
        //this.enableFocus(COLOREDBAR_FOCUS_ZONE_MINIEPG);

        const className = this.refs.miniEpgContainer.className;
        if (className.indexOf('player-controls-mini-epg-hide') > -1) {
            this.refs.miniEpgContainer.className = this.refs.miniEpgContainer.className.replace('player-controls-mini-epg-hide', '');
        }

        ShowMiniObserver.fire();
        this.setState({ miniEpgVisible: true }, () => {
            this.animateColoredBar('coloredBarMini');
        });
        this.skipIntroPositionUp();
    }

    /**
   * Position Skip Intro
   */
    skipIntroPositionUp() {
        if (this.refs && this.refs.skipIntro && this.hasSkipIntro) {
            const className = this.refs.skipIntro.className;
            const classNameReplace = className.replace('skip-intro-down', 'skip-intro-up');
            this.refs.skipIntro.className =
                className.indexOf('skip-intro-down') > -1 ? classNameReplace : className;
        }
    }

    hideAll() {
        this.stopAutoHideTimer();
        if (this.state.visible) this.hide();
        if (this.state.miniEpgVisible) this.hideMini();
    }

    /**
     * Método para ocultar SÓLO PlayerControls (No controla la mini)
     */
    hide(cbk = null) {


        this.stopAutoHideTimer();
        // Nada que hacer si el otro player controls tiene el control
        // (para controlar observers)
        if (!this.enabledForThisContentStreamType()) return;

        this.props.controlBarIsShowed(false);

        this.resetAnimateColoredBar('coloredBarControls');
        this.restoreVideoControlsSize();
        this.disableFocus();
        this.disableFocus(COLOREDBAR_FOCUS_ZONE_PLAYERCONTROLS);
        console.log('[NPC] try hide, this.state.visible: ', this.state.visible);

        const className = this.refs.playerControlsContainer.className;
        if (className.indexOf('player-controls-hide') === -1) {
            this.refs.playerControlsContainer.className += 'player-controls-hide';
        }
        if (!this.state.visible) return;

        this.setState({ visible: false }, () => {
            const titlesb = Array.from(document.querySelectorAll('.video-player-control-button-title'));
            titlesb && Array.isArray(titlesb) && titlesb.length > 0 && titlesb.forEach((bt) => {
                bt.classList.remove('player-controls-vod-title-empha');
            });
            // if (this.shouldHideSkipIntro()) {
            //     this.hideSkipIntro();
            // }
            // else {
            // Si se oculta playercontrols y esta
            // skip intro visible, entonces se devuelve
            // el foco a skip
            if (this.state.skipIntroVisible) {
                this.focus('.skip-intro-button');
            }
            this.managePlayerControlsSkipIntroFocus();
            if(cbk) cbk();
        });
      //Oculta foco dinámico cuando se oculta la mini
      removeDynamicFocus();
    }

    hideMini() {
        this.stopAutoHideTimer();
        // Nada que hacer si el otro player controls tiene el control
        // (para controlar observers)
        if (!this.enabledForThisContentStreamType()) return;

        this.resetAnimateColoredBar('coloredBarMini');
        this.disableFocus(COLOREDBAR_FOCUS_ZONE_MINIEPG);
        HideMiniObserver.fire();
        console.log('[NPC] try hide, this.state.miniEpgVisible: ', this.state.miniEpgVisible);
        if (!this.state.miniEpgVisible) return;

        const className = this.refs.miniEpgContainer.className;
        if (className.indexOf('player-controls-mini-epg-hide') === -1) {
            this.refs.miniEpgContainer.className += 'player-controls-mini-epg-hide';
        }
        this.setState({ miniEpgVisible: false });
        //Oculta foco dinámico cuando se oculta la mini
        removeDynamicFocus();

    }

    restoreVideoControlsSize() {
        /**
        * Resize player buttons
        */
        const videoControlButtons = Array.from(document.querySelectorAll('.video-player-control-button'));
        videoControlButtons &&
            Array.isArray(videoControlButtons) &&
            videoControlButtons.map((btn, index) => {
                btn.style.height = `${videoControlHeight}px`;
                btn.style.width = `${videoControlWidth}px`;
            });

        const ball = document.getElementById('player-ui-progress-bar-ball');
        if (ball) ball.className = ball.className.replace(' player-slider-bar-ball-focus', '');
    }

    /**
     * Listeners via refs, from video/index
     * TODO NPC: Is it better to set duration as re-render or with a ref ¿?
     */
    onDurationChange(duration) {
        this.setDuration(duration);
    }
    /**
     * END - Listeners via refs, from video/index
     */

    setCurrentTime(currentTime) {
        this.currentTime = currentTime;
    }

    getCurrentTime(currentTime) {
        return this.currentTime;
    }

    setDuration(duration) {
        this.duration = duration;
    }

    getDuration() {
        return this.duration;
    }

    onCanPlay() {
        this.canPlay = true;
        this.setState({ playing: true });
    }

    /**
     *
     * @param {*} currentTime si es VOD se manda el current time
     */
    onPause(currentTime, cbState) {
        console.log('WHENPAUSE esta en pausa');
        this.setState({ playing: false },
            () => {
                // Antes
                //  Siempre se oculta player controls
                // Ahora
                //  En startover o en catchup, cuando estén en pausa
                //  no se oculta player controls

                // en onPause entra el pause y el trickmode (fastForward, fastBackward)
                switch (this.state.contentStreamType) {
                    case AAF_CONTENT_IS_CATCHUP:
                    case AAF_CONTENT_IS_STARTOVER:
                    case AAF_CONTENT_IS_NPVR:
                    case AAF_CONTENT_IS_TV:
                        this.stopAutoHideTimer();
                        this.focus('.video-player-control-main-button-play');
                        console.log('WHENPAUSE solo se hace stop del autohide');
                        break;
                    case AAF_CONTENT_IS_AUDIO:
                    case AAF_CONTENT_IS_RADIO:
                        const state = store.getState();
                        const statePlayerMusic = state.playermusica;
                        const playlistLength = this.state.contentStreamType !== AAF_CONTENT_IS_RADIO ? statePlayerMusic.playlist.originalContent.length : 0;
                        const currentIndex = parseInt(statePlayerMusic.currentContent.index);
                        const isLastElement = playlistLength - 1 === currentIndex;

                        //? Se ha llegado a la ultima cancion de la lista de reproduccion
                        if (isLastElement && this.getCurrentTime() >= 29 && store.dispatch(isPreviewSong())) {
                            this.canPlay = false;
                        }
                        break;
                    default:
                        this.resetAutoHideTimer();
                        console.log('WHENPAUSE se ocultara en unos segundos');
                        break;
                }
                cbState();
            });

        // Metric
        PlayerControlsLogic.sendMetric('pausa', null, this.props.dataMetric, this.props.setMetricsEvent, false, this.getCurrentTimeInMinutes(), this.getDurationInMinutes());
        this.sendGA4Metric('G2')
    }

    /**
     * VOD Si el user se esta moviendo en el slide o en el forward/backward
     * al inicio de una serie-episodio, esta variable bloquea al skip intro
     * @param {} val
     */
    onIsMoving(val) {
        console.log('[MOVING] isMoving = ', val);
        this.isMoving = val;
    }

    /**
        *
        * @param {*} currentTime si es VOD se manda el current time
        */
    onPlay(cbState) {
        this.setState({ playing: true }, cbState);
        switch (this.state.contentStreamType) {
            case AAF_CONTENT_IS_AUDIO:
            case AAF_CONTENT_IS_RADIO:
                const state = store.getState();
                const statePlayerMusic = state.playermusica;
                const playlistLength = this.state.contentStreamType !== AAF_CONTENT_IS_RADIO ? statePlayerMusic.playlist.originalContent.length : 0;
                const currentIndex = parseInt(statePlayerMusic.currentContent.index);
                const isLastElement = playlistLength - 1 === currentIndex;

                //? Se ha llegado a la ultima cancion de la lista de reproduccion
                if (isLastElement && this.getCurrentTime() >= 29 && store.dispatch(isPreviewSong())) {
                    this.canPlay = false;
                    this.setState({ playing: false }, cbState);
                }
                break;
            default:
                this.resetAutoHideTimer();
                break;
        }
        // Metric
        PlayerControlsLogic.sendMetric('reproducir', null, this.props.dataMetric, this.props.setMetricsEvent, false, this.getCurrentTimeInMinutes(), this.getDurationInMinutes());
    }

    onBackward(cbState) {
        this.sendGA4Metric('G3')
        this.resetAutoHideTimer();
    }

    onForward(cbState) {
        this.sendGA4Metric('G4')
        this.resetAutoHideTimer();
    }

    /*
    direction = left | right
    */
    onSlide(cbState, direction) {
        const {currentTime, duration = 0} = this;
        const progress_percentage = duration === 0 ? 0 : Math.round((currentTime / duration  ) * 100);
        if (this.progress_percentage !== progress_percentage) {
            const _slider = document.getElementsByClassName('player-slider-bar-now');
            let slider = Array.from(_slider);
            slider = slider[0];
            const {style : {width = ''} = {}} = slider || {};
            this.sendGA4Metric('G6' , width)
        }
        this.progress_percentage = progress_percentage;

        if (!this.isLiveWithTimeshift()) {
            // Si es canal tv sin TS, se lanza una notificación,
            // entonces no se resetea el timer del autohide,
            // playercontrols live oculta player controls
            return;
        }

        // Si esta en pausa no se resetea, no se ocultará PC
        // Si esta en play se resetea y lanza el timer para ocultar PC
        if(this.state.playing) {
            this.resetAutoHideTimer();
        }
        else {
            switch(this.state.contentStreamType) {
                case AAF_CONTENT_IS_TV:
                case AAF_CONTENT_IS_CATCHUP:
                case AAF_CONTENT_IS_STARTOVER:
                case AAF_CONTENT_IS_NPVR:
                this.stopAutoHideTimer();
                break;
                default:
                    this.resetAutoHideTimer();
                    break;
            }
        }
    }

    onStopMediaPlay() {
        this.canPlay = false;
    }

    // TODO Verificar este método
    eventIsRecording() {
        if (!this.state) {
            return false;
        }

        if (!this.state.timeshiftEventInfo) {
            return false;
        }

        if (!this.state.timeshiftEventInfo.event) {
            return false;
        }

        const { timeshiftEventInfo: { event: { recording_status = null } = {} } = {} } = this.state;

        return recording_status === 2 || recording_status === 3 || recording_status === 4;
    }

    getEventRecordingStatus() {
        if (!this.state) {
            return 0;
        }

        if (!this.state.timeshiftEventInfo) {
            return 0;
        }

        if (!this.state.timeshiftEventInfo.event) {
            return 0;
        }

        const { timeshiftEventInfo: { event: { recording_status = null } = {} } = {} } = this.state;

        return parseInt(recording_status);
    }

    getNowEventCb(event) {
        const playerParams = this.props.playingResolvedParams();
        if (playerParams && event) {
            this.sendMetricNew('player', event, playerParams);
        }

        this.setState({
            normalEventInfo: event,
            timeshiftEventInfo: null
        });
    }

    /**
     * Recuperar el evento que esta en reproducción, esto es porque si es canal
     * con TS entonces el evento se pasa directamente desde video index, se manda a llamar
     * el api o el query a database android
     */
    requestEventInPlay() {
        let eventInPlay = null;
        const playerParams = this.props.playingResolvedParams();
        let hasTS = false;
        let groupId = null;
        if (this.state.contentStreamType === AAF_CONTENT_IS_NPVR) {
            // NPVR trae el evento en el onResolveParams, en timeshiftEvent
            hasTS = true;
        }
        else {
            groupId = playerParams && playerParams.groupId ? playerParams.groupId : null;
            if (!groupId) return eventInPlay;
            hasTS = AAF.Timeshift.hasTimeshift(groupId);
        }

        if (hasTS) {
            // Si es canl CON TS se manda el del state
            if (this.state.timeshiftEventInfo && this.state.timeshiftEventInfo.event) {
                eventInPlay = this.state.timeshiftEventInfo.event;
            }
        }
        else {
            // Si es canl SIN TS se manda el del state, pero el normal event
            if (this.state.normalEventInfo && this.state.normalEventInfo) {
                eventInPlay = this.state.normalEventInfo;
            }
        }

        console.log('[TSEVENT] event title: ', (eventInPlay && eventInPlay.name ? eventInPlay.name : null));

        return eventInPlay;
    }

    isMultipleLiveLangEnabled() {
        let maEnabled = false;
        const eventInPlay = this.requestEventInPlay();
        if (eventInPlay) {
            const playerParams = this.props.playingResolvedParams();
            const { streamType = null } = playerParams;
            maEnabled = EventOptionsUtils.isMAEnabled(eventInPlay, streamType, this.state.contentStreamType);
        }

        return maEnabled;
    }

    /**
     * OJO Para el seek por el momento sólo VOD pasa por aquí (por el skip intro)
     */
    seek(time) {
        console.log('[SKI] se hace el SEEK a time: ', time);
        this.props.seek(time);
        if (this.state.contentStreamType === AAF_CONTENT_IS_VOD) {
            this.playerControlsActivityNotifier.sendActivity(new PlayerControlsActivity(SEEK_VOD_PLAYER_CONTROLS_EVENT, { seekTo: time, currentTime: this.getCurrentTime() }));
        }
    }

    addRecordingButton({ defaultButtons, timeshiftEventInfo, addValue }) {

        const isRecording = timeshiftEventInfo ? NpvrUtil.viewButtonRecording(timeshiftEventInfo) : false;
        const auxDefaultButtons = [...defaultButtons];

        if (isRecording) auxDefaultButtons.unshift(addValue)

        return auxDefaultButtons

    }

    getPlayerControls() {
        const streamContentType = this.state.contentStreamType;
        const { ispreview } = this.props;
        let pc = null;
        switch (streamContentType) {
            case AAF_CONTENT_IS_TV:

                pc = this.isLiveWithTimeshift() ? <PlayerControlsLiveTS
                    clearLoading={this.props.clearLoading}
                    ref="playerControls"
                    // Player bar commands/controls
                    onPause={this.onPause}
                    onPlay={this.onPlay}
                    onBackward={this.onBackward}
                    onSlide={this.onSlide}
                    onExit = {this.back}
                    onRecording={this.onRecording}
                    onEpg={this.onToggleEpg}
                    onLanguage={this.onShowLanguages}

                    // Player controls state
                    playing={this.state.playing} // Está en play
                    visible={this.state.visible} // PlayerControls esta visible o no

                    pause={this.props.pause}
                    hide={this.hide}
                    hideMini={this.hideMini}
                    focus={this.focus}
                    doStartOver={this.props.doStartOver}
                    onUpdateCurrentTimeshift={this.props.onUpdateCurrentTimeshift}
                    isChangingChannel={this.isChangingChannel}
                    enabled={this.canPlay}
                    isMultipleLiveLangEnabled={this.isMultipleLiveLangEnabled}
                    eventIsRecording={this.eventIsRecording}
                    getEventRecordingStatus={this.getEventRecordingStatus}
                    getPlayerControlsButtonNavigation={this.getPlayerControlsButtonNavigation}
                    addRecordingButton={this.addRecordingButton}
                /> : <PlayerControlsLive
                    ref="playerControls"
                    clearLoading={this.props.clearLoading}
                    // Player bar commands/controls
                    onEpg={this.onToggleEpg}
                    onLanguage={this.onShowLanguages}
                    onSlide={this.onSlide}
                    // Player controls state
                    playing={this.state.playing} // Está en play
                    visible={this.state.visible} // PlayerControls esta visible o no
                    onExit = {this.back}

                    hide={this.hide}
                    hideMini={this.hideMini}
                    focus={this.focus}

                    onUpdateCurrentTimeshift={this.props.onUpdateCurrentTimeshift}
                    isChangingChannel={this.isChangingChannel}
                    enabled={this.canPlay}
                    isMultipleLiveLangEnabled={this.isMultipleLiveLangEnabled}
                    eventIsRecording={this.eventIsRecording}
                    getEventRecordingStatus={this.getEventRecordingStatus}
                    getPlayerControlsButtonNavigation={this.getPlayerControlsButtonNavigation}
                    normalEventInfo={this.state.normalEventInfo}
                    getNowEvent={this.getNowEvent}
                    showNotificationNoSlide={this.showNotificationNoSlide}
                />

                break;
            case AAF_CONTENT_IS_STARTOVER:
                pc = <PlayerControlsStartover
                    clearLoading={this.props.clearLoading}
                    ref="playerControls"
                    // Player bar commands/controls
                    onExit={this.back}
                    onPause={this.onPause}
                    onPlay={this.onPlay}
                    onBackward={this.onBackward}
                    onForward={this.onForward}
                    onSlide={this.onSlide}
                    resetAutoHideTimer={this.resetAutoHideTimer}

                    onRecording={this.onRecording}
                    onEpg={this.onToggleEpg}
                    onLanguage={this.onShowLanguages}

                    // Player controls state
                    playing={this.state.playing} // Está en play
                    visible={this.state.visible} // PlayerControls esta visible o no

                    play={this.props.play}
                    pause={this.props.pause}
                    seek={this.props.seek}
                    hide={this.hide}
                    focus={this.focus}
                    doStartOver={this.props.doStartOver}
                    onUpdateCurrentTimeshift={this.props.onUpdateCurrentTimeshift}

                    speedForward={this.props.speedForward}
                    speedBackward={this.props.speedBackward}
                    setSpeed={this.props.setSpeed}
                    goToLive={this.props.goToLive}
                    setTimer={this.setTimer}
                    enabled={this.canPlay}
                    isMultipleLiveLangEnabled={this.isMultipleLiveLangEnabled}
                    eventIsRecording={this.eventIsRecording}
                    getEventRecordingStatus={this.getEventRecordingStatus}
                    getPlayerControlsButtonNavigation={this.getPlayerControlsButtonNavigation}
                    addRecordingButton={this.addRecordingButton}
                />
                break;
            case AAF_CONTENT_IS_CATCHUP:
                pc = <PlayerControlsCatchup
                    clearLoading={this.props.clearLoading}
                    ref="playerControls"
                    // Player bar commands/controls
                    onPause={this.onPause}
                    onPlay={this.onPlay}
                    onBackward={this.onBackward}
                    onForward={this.onForward}
                    onSlide={this.onSlide}
                    resetAutoHideTimer={this.resetAutoHideTimer}
                    onExit={this.back}

                    onRecording={this.onRecording}
                    onEpg={this.onToggleEpg}
                    onLanguage={this.onShowLanguages}

                    // Player controls state
                    playing={this.state.playing} // Está en play
                    visible={this.state.visible} // PlayerControls esta visible o no

                    play={this.props.play}
                    pause={this.props.pause}
                    seek={this.props.seek}
                    hide={this.hide}
                    focus={this.focus}
                    getDuration={this.getDuration}

                    onUpdateCurrentTimeshift={this.props.onUpdateCurrentTimeshift}

                    speedForward={this.props.speedForward}
                    speedBackward={this.props.speedBackward}
                    setSpeed={this.props.setSpeed}
                    setTimer={this.setTimer}
                    enabled={this.canPlay}
                    isMultipleLiveLangEnabled={this.isMultipleLiveLangEnabled}
                    eventIsRecording={this.eventIsRecording}
                    getEventRecordingStatus={this.getEventRecordingStatus}
                    getPlayerControlsButtonNavigation={this.getPlayerControlsButtonNavigation}
                    addRecordingButton={this.addRecordingButton}
                />
                break;
            case AAF_CONTENT_IS_NPVR:
                pc = <PlayerControlsNpvr
                    ref="playerControls"
                    clearLoading={this.props.clearLoading}
                    // Player bar commands/controls
                    onPause={this.onPause}
                    onPlay={this.onPlay}
                    onBackward={this.onBackward}
                    onForward={this.onForward}
                    onSlide={this.onSlide}
                    resetAutoHideTimer={this.resetAutoHideTimer}
                    onExit={this.back}

                    onRecording={this.onRecording}
                    onEpg={this.onToggleEpg}
                    onLanguage={this.onShowLanguages}

                    // Player controls state
                    playing={this.state.playing} // Está en play
                    visible={this.state.visible} // PlayerControls esta visible o no

                    play={this.props.play}
                    pause={this.props.pause}
                    seek={this.props.seek}
                    hide={this.hide}
                    focus={this.focus}

                    getDuration={this.getDuration}

                    onUpdateCurrentTimeshift={this.props.onUpdateCurrentTimeshift}

                    speedForward={this.props.speedForward}
                    speedBackward={this.props.speedBackward}
                    setSpeed={this.props.setSpeed}
                    setTimer={this.setTimer}
                    enabled={this.canPlay}
                    getPlayerControlsButtonNavigation={this.getPlayerControlsButtonNavigation}
                />
                break;
            case AAF_CONTENT_IS_VOD:
                pc = <PlayerControlsVod
                    ispreview={ispreview}
                    ref="playerControls"
                    clearTimeOutAAF={this.props.clearTimeOutAAF}
                    startTimeOutAAF={this.props.startTimeOutAAF}
                    // Functions
                    onExit={this.back}
                    onSerie={this.onSelectEpisodes}
                    onLanguage={this.onShowLanguages}
                    onPause={this.onPause}
                    onPlay={this.onPlay}
                    onBackward={this.onBackward}
                    onForward={this.onForward}
                    onSlide={this.onSlide}
                    onIsMoving={this.onIsMoving}

                    // Player controls state
                    playing={this.state.playing} // Está en play
                    visible={this.state.visible} // PlayerControls esta visible o no

                    // external methods
                    seek={this.seek}
                    pause={this.props.pause}
                    play={this.props.play}
                    getDuration={this.getDuration}
                    enabled={this.canPlay}

                    focus={this.focus}
                    serieData={this.state.serieData}

                    hideAll={this.hideAll}
                    showSprites={this.showSprites}
                    updateSprite={this.updateSprite}
                    hideSprites={this.hideSprites}
                    contentSprite={this.contentSprite}
                    canShowSprites={this.canShowSprites}
                    // updateCurrentTimeSprite={this.updateCurrentTimeSprite}
                    updateSpritePosition={this.updateSpritePosition}
                    getPlayerControlsButtonNavigation={this.getPlayerControlsButtonNavigation}
                />
                break;
            default:
                pc = <PlayerControlsEmpty
                    ref="playerControls"
                    getPlayerControlsButtonNavigation={this.getPlayerControlsButtonNavigation}
                />
                break;
        }

        return pc;
    }

    sendMetricNew(action, timeshiftEventInfo, playerParams) {
        if (playerParams && timeshiftEventInfo) {
            const contentStreamType = this.state.contentStreamType;
            switch (contentStreamType) {
                case AAF_CONTENT_IS_TV:
                case AAF_CONTENT_IS_STARTOVER:
                case AAF_CONTENT_IS_CATCHUP:
                    const groupId = timeshiftEventInfo ? timeshiftEventInfo.group_id || '' : '';
                    if (groupId) {
                        const channelInfo = channelStreamUtil.get(groupId);
                        const channelNumber = channelInfo ? channelInfo.channel_number || '' : '';
                        const channelTitle = channelInfo ? channelInfo.title || '' : '';
                        const eventTitle = timeshiftEventInfo && timeshiftEventInfo.name ? timeshiftEventInfo.name : '';

                        if (channelNumber && eventTitle) {
                            PlayerControlsLogic.sendMetric(action, `${channelNumber} ${channelTitle} / ${eventTitle}`, this.props.dataMetric, this.props.setMetricsEvent, false, this.getCurrentTimeInMinutes(), this.getDurationInMinutes());
                        }
                    }
                    break;
                case AAF_CONTENT_IS_VOD:
                    break;
                case AAF_CONTENT_IS_NPVR:
                    break;
                default:
                    break;
            }
        }
    }

    isLiveWithTimeshift() {
        let isWithTS = false;

        const playerParams = this.props.playingResolvedParams();

        if (playerParams) {
            const groupId = playerParams && playerParams.groupId ? playerParams.groupId : null;
            const hasTS = AAF.Timeshift.hasTimeshift(groupId);
            // Estamos en canal live y es canal sin TS
            if (hasTS) {
                isWithTS = true;
            }
        }

        return isWithTS;
    }

    getNowEvent() {
        const playerParams = this.props.playingResolvedParams();
        if (playerParams) {
            const groupId = playerParams && playerParams.groupId ? playerParams.groupId : null;
            AAF.Timeshift.getNowEvent(groupId, this.getNowEventCb, false);
        }
    }

    /**
     * IMPORTANTE
     * TODO Manejar un sólo event en ambos:
     * <PlayerControlsLiveTS /> y <PlayerControlsLive />
     *
     * TODO sacar la lógica del progress time de abstractHTML5Player y repartirla en
     * <PlayerControlsLiveTS />  <PlayerControlsLive /> según sea el caso
     * (En <PlayerControlsLive /> ya se hizo lo de arriba, tomarlo como ejemplo para TS)
     */
    setTimeshiftEventInfo(timeshiftEventInfo) {
        /**
         * Para el caso de canales live sin TS
         */
        if (!this.isLiveWithTimeshift() && this.state.contentStreamType === AAF_CONTENT_IS_TV) {
            const isch = this.props.isChangingChannel();
            !isch && this.getNowEvent();

            return;
        }

        const playerParams = this.props.playingResolvedParams();
        // Se manda el metric de reproductor live con canal ts
        // (para la métrica de live sin ts se manda en getNowEventCb)
        if (playerParams && timeshiftEventInfo && timeshiftEventInfo.event) {
            this.sendMetricNew('player', timeshiftEventInfo.event, playerParams);
        }

        /**
         * Considerar:
         *  - En catchup el player de android manda el NowEvent en null, entonces este evento
         * NO lo consideramos aquí.
         * El evento que consideramos para catchup es el que nos envia video/index > onResolveParams
         * Lo mismo de arriba aplica para el NPVR
         *
         * TV y startover sí recuperan el nowEvent
         *
         */
        if (this.state.contentStreamType === AAF_CONTENT_IS_CATCHUP && timeshiftEventInfo === null) {
            return;
        }

        // TODO this.switchingBetweenEventTimeshift = false;
        console.log('[NPC] function setTimeshiftEventInfo > ' + this.switchingBetweenEventTimeshift);
        // timeshiftEventInfo can be NULL

        // Map date begin and date end to unix timestamp
        if (timeshiftEventInfo && timeshiftEventInfo.event) {
            if (isNaN(timeshiftEventInfo.event.date_begin)) {
                const dBegin = new Dates(timeshiftEventInfo.event.date_begin);
                timeshiftEventInfo.event.date_begin = dBegin.unix();
            }
            if (isNaN(timeshiftEventInfo.event.date_end)) {
                const dEnd = new Dates(timeshiftEventInfo.event.date_end);
                timeshiftEventInfo.event.date_end = dEnd.unix();
            }
            if (!isNaN(timeshiftEventInfo.event.duration)) {
                timeshiftEventInfo.event.duration = new Date(timeshiftEventInfo.event.duration * 1000).toISOString().substr(11, 8);
            }
        }

        const event = timeshiftEventInfo && timeshiftEventInfo.event ? timeshiftEventInfo.event : null;

        event && this.setState({
            timeshiftEventInfo
        }, () => {
            if (this.refs['playerControls'] && this.refs['playerControls'].setTimeshiftEventInfo) {
                this.playerAlreadyHasVideo && this.playerSetTimeshiftEventInfoCounter++;
                console.log('[NPC2] Live lleva event info');
                this.refs['playerControls'].setTimeshiftEventInfo(timeshiftEventInfo);
                // IMPORTANTE: por aquí no pasa catchup
                if(this.playerSetTimeshiftEventInfoCounter === 1 && this.playerAlreadyHasVideo) {
                    /**
                     * Desde aquí se manda la métrica G1 para tv en vivo y startover
                     *
                     * Para catchup, VOD, npvr se manda desde método de arriba whenPlayerHasVideo()
                     */
                     switch(this.state.contentStreamType) {
                        case AAF_CONTENT_IS_TV:
                        case AAF_CONTENT_IS_STARTOVER:
                            this.sendGA4Metric('G1');
                        break;
                        default:
                        break;
                     }
                }
            }
        });
    }

    onSeekStartOver(seekWasTo) {
        if (this.refs.playerControls && this.refs.playerControls.onSeekStartOver) {
            this.refs.playerControls.onSeekStartOver(seekWasTo);
        }

        this.switchingBetweenEventTimeshift = false;
        console.log('[NPC] Startover function onSeekStartOver ' + this.switchingBetweenEventTimeshift);
    }

    onRateChange(speed, direction, frompause) {
        if (this.refs.playerControls && this.refs.playerControls.onRateChange) {
            this.refs.playerControls.onRateChange(speed, direction, frompause);
        }
    }

    hideControls() {
        // Se ocultan player controls
        this.hide();
        // Se muestra la mini
        this.showMini();
        // TODO
        this.verifySetAutoHide();
        this.disableFocus();
    }

    // TODO se deja por compatibilidad, eliminarlo después
    verifySetAutoHide() {
    }

    enabledControlsTS() {
        if (EventTimeshift.isEnabled() && this.state && this.state.contentStreamType) {
            return this.state.contentStreamType === AAF_CONTENT_IS_STARTOVER;
        } else {
            return false;
        }
    }

    // Show player controls desde mini o visceversa
    toggleControls() {

        if (!this.enabledForThisContentStreamType()) return;
        const isChangingChannel = this.props.isChangingChannel();

        let currentContentStreamType = this.state.contentStreamType;
        if (!this.state.playing && currentContentStreamType === AAF_CONTENT_IS_TV && this.canPlay) {
            if (this.state.visible) {
                return;
            }

            if (this.state.miniEpgVisible) {
                this.hideMini();
            }

            this.show();

            return;
        }

        // PC visible
        if (this.state.visible) {
            // Si PC visible, hide and show mini
            this.hide();
            this.showMini();
        }
        // Mini visible
        else if (this.state.miniEpgVisible) {
            // Si esta haciendo una transición de cambio de canal
            // y la mini ya está visible  se deja visible
            if (!isChangingChannel) {
                // Si esta cancelando pin sigue en TV y se muestra
                this.hideMini();
                this.show();
            }
            else {
                // TODO Quizá reset del autohidden ¿?
            }
        }
        else {

            // Resolver por streamType
            switch (currentContentStreamType) {
                // TODO controlar cuando es TV y se esta en pausa, es decir antes de entrar en startover
                case AAF_CONTENT_IS_TV:
                    this.showMini();
                    break;
                case AAF_CONTENT_IS_STARTOVER: // Si esta en startover se muestra primero player controls
                    this.show();
                    break;
                case AAF_CONTENT_IS_NPVR:
                case AAF_CONTENT_IS_VOD:
                    this.show();
                    break;
                case AAF_CONTENT_IS_CATCHUP:
                    this.showMini();
                    break;
                default:
                    break;
            }
        }
    }

    enableButton(colorCode) {
        return Utils.isColorInPlayerControlEnable(colorCode);
    }

    /**
     * La mini persistente manda a llamar este método pero
     * aquí ya se manda a llamar el toggleControls (en el otro legacy sí)
     */
    onPressRedButton() {
    }

    goToCard(path, extradata) {
        this.hide();
        this.hideMini();
        this.props.goToCard(path, extradata);
    }

    getContentStreamType() {
        return this.state.contentStreamType;
    }

    getStreamType() {
        const playerParams = this.props.playingResolvedParams();
        const { streamType = null } = playerParams;
        return streamType;
    }

    setNormalEventInfo(event) {
        if (event) {
            this.setState({ normalEventInfo: event });
        }
    }

    getMiniEpg() {
        // La mini lokilla, persistente
        if (EpgPersistence.isDatabaseDataSource()) {
            return <Mini
                hideMiniEpgWithVisibilityValidation={this.hideMiniEpgWithVisibilityValidation}
                hideControls={this.hideControls}
                hideActionBar={() => { }}
                setCurrentEventInPlayerControls={event => {
                    this.currentEvent = { ...event };
                }}
                onUpdateEpg={this.props.onUpdateEpg}
                goToCard={this.goToCard}
                onPressRedButton={this.onPressRedButton}
                enableButton={this.enableButton}
                getContentStreamType={this.getContentStreamType}
                streamType={this.getStreamType}
                changeLang={this.props.changeLang}
                resetAutoHideTimer={this.resetAutoHideTimer}
                record={this.props.record}
            />
        }
        // La mini old, by request
        else {
            return <MiniEpgOtt
                setNormalEventInfo={this.setNormalEventInfo}
                hideMiniEpgWithVisibilityValidation={this.hideMiniEpgWithVisibilityValidation}
                hideControls={this.hideControls}
                hideActionBar={() => { }}
                setCurrentEventInPlayerControls={event => {
                    this.currentEvent = event;
                }}
                onUpdateEpg={this.props.onUpdateEpg}
                goToCard={this.goToCard}
                onPressRedButton={this.onPressRedButton}
                enableButton={this.enableButton}
                getContentStreamType={this.getContentStreamType}
                streamType={this.getStreamType}
                changeLang={this.props.changeLang}
                resetAutoHideTimer={this.resetAutoHideTimer}
                record={this.props.record}
            />
        }
    }

    /**
     * @param {*} streamContentType
     * Método para ayudar a controlar observers
     * ShowPlayerControlsObserver / HidePlayerControlsObserver
     */
    enabledForThisContentStreamType() {
        switch (this.state.contentStreamType) {
            case AAF_CONTENT_IS_TV:
            case AAF_CONTENT_IS_STARTOVER:
            case AAF_CONTENT_IS_CATCHUP:
            case AAF_CONTENT_IS_NPVR:
            case AAF_CONTENT_IS_VOD:
                return true;
            default:
                return false;
        }
    }

    enableFocus(zone = PLAYERCONTROLS_FOCUS_ZONE) {
        window.SpatialNavigation.enable(zone);
    }

    disableFocus(zone = PLAYERCONTROLS_FOCUS_ZONE) {
        window.SpatialNavigation.disable(zone);
    }

    isTrailer() {
        return store.getState().player.ispreview;
    }

    coloredBarMiniButtons() {
        let baseButtons = [
            {
                color: "green",
                metadataKeyLabel: '_',
                metadataLabelDefault: Translator.get('playingLive_miniEpg_option_button_close', 'SALIR'),
                buttonClassName: CSSNAME_FOCUSABLE_COLORED_BUTTONS,
                dataSnUp: '.video-player-control-main-button'
            },
            {
                color: "blue",
                metadataKeyLabel: '_',
                metadataLabelDefault: Translator.get('playingLive_miniEpg_option_button_menuOptions', 'MÁS OPCIONES'),
                buttonClassName: CSSNAME_FOCUSABLE_COLORED_BUTTONS,
                dataSnUp: '.video-player-control-main-button'
            },
            {
                color: "yellow",
                metadataKeyLabel: '_',
                metadataLabelDefault: Translator.get('playingLive_miniEpg_option_button_fullEpg', 'GUÍA COMPLETA'),
                buttonClassName: CSSNAME_FOCUSABLE_COLORED_BUTTONS,
                dataSnUp: '.video-player-control-main-button'
            }
        ];

        switch (this.state.contentStreamType) {
            case AAF_CONTENT_IS_TV:
                baseButtons.push(
                    {
                        color: "red",
                        metadataKeyLabel: '_',
                        metadataLabelDefault: Translator.get('playingLive_miniEpg_option_button_playerControls', 'MOSTRAR REPRODUCTOR'),
                        buttonClassName: CSSNAME_FOCUSABLE_COLORED_BUTTONS,
                        dataSnUp: '.video-player-control-main-button'
                    }
                );
                break;
            case AAF_CONTENT_IS_CATCHUP:
                baseButtons.push(
                    {
                        color: "red",
                        metadataKeyLabel: '_',
                        metadataLabelDefault: Translator.get('playingLive_miniEpg_option_button_playerControls', 'MOSTRAR REPRODUCTOR'),
                        buttonClassName: CSSNAME_FOCUSABLE_COLORED_BUTTONS,
                        dataSnUp: '.video-player-control-main-button'
                    }
                );
                break;
            case AAF_CONTENT_IS_STARTOVER:
                baseButtons.push(
                    {
                        color: "red",
                        metadataKeyLabel: '_',
                        metadataLabelDefault: Translator.get('playingLive_miniEpg_option_button_playerControls', 'MOSTRAR REPRODUCTOR'),
                        buttonClassName: CSSNAME_FOCUSABLE_COLORED_BUTTONS,
                        dataSnUp: '.video-player-control-main-button'
                    }
                );
                break;
            default:
                baseButtons = [];
                break;
        }

        return baseButtons;
    }

    manageGreenButton() {
        switch (this.state.contentStreamType) {
            case AAF_CONTENT_IS_TV:
            case AAF_CONTENT_IS_STARTOVER:
            case AAF_CONTENT_IS_CATCHUP:
                if (this.state.miniEpgVisible) this.hideMini();
                if (this.state.visible) this.hide();
                if (this.state.skipIntroVisible) this.hideSkipIntro();
                // Sale de reproductor
                this.back();
                break;
            default:
                break;
        }
    }

    /**
     * El botón azúl lo toma la mini y lanza la modal, pero si es clic sobre la coloredbar
     * entonces la modal se lanza desde aquí y no desde la mini
     * @param {} fireModal
     */
    manageBlueButton(fireModal = true) {
        switch (this.state.contentStreamType) {
            case AAF_CONTENT_IS_TV:
            case AAF_CONTENT_IS_STARTOVER:
            case AAF_CONTENT_IS_CATCHUP:
                if (this.state.miniEpgVisible) this.hideMini();
                if (this.state.visible) this.hide();
                if (this.state.skipIntroVisible) this.hideSkipIntro();

                if (fireModal) {
                    const streamType = this.getStreamType();
                    PlayerControlsLogic.sendMetric('click', 'opciones', this.props.dataMetric, this.props.setMetricsEvent, false, this.getCurrentTimeInMinutes(), this.getDurationInMinutes());
                    ModalEpgUtils.blueHandler({
                        hideEpgOutsideCb: null,
                        handleGuideCb: null,
                        data: this.isLiveWithTimeshift() ? this.state.timeshiftEventInfo.event : this.state.normalEventInfo,
                        streamType,
                        streamContentType: this.state.contentStreamType,
                        changeLangCb: this.props.changeLang
                    });
                }

                break;
            default:
                break;
        }
    }

    manageYellowButton() {
        switch (this.state.contentStreamType) {
            case AAF_CONTENT_IS_TV:
                const isTPA = this.isTPA(this.props.groupId);
                // Si nada visible, se muestra la mini
                if (!isTPA && !this.state.visible && !this.state.miniEpgVisible) {
                    this.showMini();
                }
                else {
                    if(isTPA) {
                        this.state.visible && this.hide();
                        this.state.miniEpgVisible && this.hideMini();
                        this.onToggleEpg();
                    }
                    else {
                        // Si controls visible, se muestra mini
                        if (this.state.visible) {
                            this.toggleControls();
                        }
                        else {
                            // Si mini visible, se lanza la full
                            if (this.state.miniEpgVisible) {
                                this.onToggleEpg();
                            }
                        }
                    }
                }
            break;
            case AAF_CONTENT_IS_STARTOVER:
            case AAF_CONTENT_IS_CATCHUP:
                // Si nada visible, se muestra la mini
                if (!this.state.visible && !this.state.miniEpgVisible) {
                    this.showMini();
                }
                else {
                    // Si controls visible, se muestra mini
                    if (this.state.visible) {
                        this.toggleControls();
                    }
                    else {
                        // Si mini visible, se lanza la full
                        if (this.state.miniEpgVisible) {
                            this.onToggleEpg();
                        }
                    }
                }
                break;
            case AAF_CONTENT_IS_VOD:
            case AAF_CONTENT_IS_NPVR:
                if (this.state.miniEpgVisible) this.hideMini();
                if (this.state.visible) this.hide();
                if (this.state.skipIntroVisible) this.hideSkipIntro();
                // Sale de reproductor
                this.back();
            default:
                break;
        }
    }

    manageRedButton() {
        switch (this.state.contentStreamType) {
            case AAF_CONTENT_IS_TV:
                if(!this.isTPA(this.props.groupId)) {
                    /**
                     * Si player controls es visible
                     * entonces se intenta pasar a startover
                     * desde el inicio
                     */
                    if(this.state.visible && this.canPlay && this.state.timeshiftEventInfo) {
                        if(this.refs.playerControls && this.refs.playerControls.calculateFinalSeekTime) {
                            this.enableButton('red') && this.refs.playerControls.calculateFinalSeekTime(true, 0);
                        }
                    }
                    else {
                        // Si la mini esta visible, se muestra el player
                        this.state.miniEpgVisible && this.enableButton('red') && this.toggleControls();
                    }
                }
                break;
            case AAF_CONTENT_IS_STARTOVER:
                /**
                 * Si player controls visible
                 * entonces salta a live
                 */
                if (this.state.visible) {
                    this.back();
                }
                // Si esta visible la mini
                else {
                    this.toggleControls();
                }
                break;
            case AAF_CONTENT_IS_CATCHUP:
                if (this.state.miniEpgVisible) {
                    this.toggleControls();
                }
                else {
                    if (this.state.visible) {
                        let category = 'reproductor tv';
                        PlayerControlsLogic.sendMetric('click', 'salir', this.props.dataMetric, this.props.setMetricsEvent, false, this.getCurrentTimeInMinutes(), this.getDurationInMinutes(), category);
                        if (this.state.visible) {
                            const cbk = () => {
                                this.props.goToLive(this.setTimer);
                            };
                            this.hide(cbk);
                        }
                        else {
                            this.props.goToLive(this.setTimer);
                        }
                    }
                    else {
                        this.toggleControls();
                    }
                }
                break;
            default:
                break;
        }
    }

    coloredBarPlayerButtons() {
        let idx = 0;
        let baseButtons = [
            {
                color: "green",
                metadataKeyLabel: '_',
                metadataLabelDefault: Translator.get('playing_playerControls_option_button_exit', 'SALIR'),
                buttonClassName: CSSNAME_FOCUSABLE_COLORED_BUTTONS,
                onClick: this.manageGreenButton,
                id: `cb${idx++}` + 'PC'

            },
            {
                color: "blue",
                metadataKeyLabel: '_',
                metadataLabelDefault: Translator.get('playingLive_playerControls_option_button_menuOptions', 'MÁS OPCIONES'),
                buttonClassName: CSSNAME_FOCUSABLE_COLORED_BUTTONS,
                onClick: this.manageBlueButton,
                id: `cb${idx++}` + 'PC'
            },
            {
                color: "yellow",
                metadataKeyLabel: '_',
                metadataLabelDefault: Translator.get('playingLive_playerControls_option_button_miniEpg', 'MINI GUÍA'),
                buttonClassName: CSSNAME_FOCUSABLE_COLORED_BUTTONS,
                onClick: this.manageYellowButton,
                id: `cb${idx++}` + 'PC'
            }
        ];

        switch (this.state.contentStreamType) {
            case AAF_CONTENT_IS_TV:
                this.isLiveWithTimeshift() && baseButtons.push(
                    {
                        color: "red",
                        metadataKeyLabel: '_',
                        metadataLabelDefault: Translator.get('playingLive_playerControls_option_button_playFromTheStart', 'VER DESDE EL INICIO'),
                        buttonClassName: CSSNAME_FOCUSABLE_COLORED_BUTTONS,
                        onClick: this.manageRedButton,
                        id: `cb${idx++}` + 'PC'
                    }
                );
                break;
            case AAF_CONTENT_IS_STARTOVER:
            case AAF_CONTENT_IS_CATCHUP:
                baseButtons.push(
                    {
                        color: "red",
                        metadataKeyLabel: '_',
                        metadataLabelDefault: Translator.get('playingLive_playerControls_option_button_playFromNow', 'VER AHORA'),
                        buttonClassName: CSSNAME_FOCUSABLE_COLORED_BUTTONS,
                        onClick: this.manageRedButton,
                        id: `cb${idx++}` + 'PC'
                    }
                );
                break;
            case AAF_CONTENT_IS_VOD:
            case AAF_CONTENT_IS_NPVR:
                idx = 0; // En este caso sólo un botón, se reinicia el contador
                baseButtons = [
                    {
                        color: "yellow",
                        metadataKeyLabel: '_',
                        metadataLabelDefault: Translator.get('playing_playerControls_option_button_exit', 'SALIR'),
                        buttonClassName: CSSNAME_FOCUSABLE_COLORED_BUTTONS,
                        onClick: this.manageYellowButton,
                        id: `cb${idx++}` + 'PC'
                    }
                ];
                break;
            default:
                baseButtons = [];
                break;
        }

        return baseButtons;
    }

    // Important cssName miniepg-colored-bar-zone for enable focus zone
    getColoredMini() {
        let colored = null;
        const focusZone = 'miniepg-colored-bar-zone';
        switch (this.state.contentStreamType) {
            case AAF_CONTENT_IS_TV:
                let cssName = `${focusZone} player-controls-colored-bar-mini-timeshift`;

                // Se valida primero que todo event TS sea null...
                let notTs = true;
                if (!this.state.timeshiftEventInfo) {
                    notTs = false;
                }
                // ...luego se valida que si viene evento TS, el attr event realmente tenga el evento
                if (this.state.timeshiftEventInfo) {
                    if (!this.state.timeshiftEventInfo.event) {
                        notTs = false;
                    }
                }

                if (!notTs) {
                    cssName = `${focusZone} player-controls-colored-bar-mini-timeshift`;
                }
                colored = <div ref="coloredBarMini" id="coloredBarWrapperMini" className={cssName}>
                    <ColoredBar className="colored-bar-full" type="normal" buttons={this.coloredBarMiniButtons()} />
                </div>
                break;
            case AAF_CONTENT_IS_CATCHUP:
                colored = <div ref="coloredBarMini" id="coloredBarWrapperMini" className={`${focusZone} player-controls-colored-bar-mini-timeshift`}>
                    <ColoredBar className="colored-bar-full" type="normal" buttons={this.coloredBarMiniButtons()} />
                </div>
                break;
            case AAF_CONTENT_IS_STARTOVER:
                colored = <div ref="coloredBarMini" id="coloredBarWrapperMini" className={`${focusZone} player-controls-colored-bar-zone player-controls-colored-bar-mini-timeshift`}>
                    <ColoredBar className="colored-bar-full" type="normal" buttons={this.coloredBarMiniButtons()} />
                </div>
                break;
            default:
                break;
        }

        return colored;
    }

    getColoredControls() {
        let colored = null;
        const focusZone = 'playercontrols-colored-bar-zone';
        switch (this.state.contentStreamType) {
            case AAF_CONTENT_IS_TV:

                let cssName = `${focusZone} player-controls-colored-bar-controls`;
                if (!this.isLiveWithTimeshift()) {
                    cssName = `${focusZone} player-controls-colored-bar-controls-alt3`;
                }

                colored = <div ref="coloredBarControls" id="coloredBarWrapper" className={cssName}>
                    <ColoredBar getNavigation={this.getColoredBarControlsNavigation} type="tabs" buttons={this.coloredBarPlayerButtons()} />
                </div>

                break;
            case AAF_CONTENT_IS_STARTOVER:
                colored = <div ref="coloredBarControls" id="coloredBarWrapper" className="player-controls-colored-bar-controls">
                    <ColoredBar getNavigation={this.getColoredBarControlsNavigation} type="tabs" buttons={this.coloredBarPlayerButtons()} />
                </div>
                break;
            case AAF_CONTENT_IS_CATCHUP:
                colored = <div ref="coloredBarControls" id="coloredBarWrapper" className="player-controls-colored-bar-controls-alt3">
                    <ColoredBar getNavigation={this.getColoredBarControlsNavigation} type="tabs" buttons={this.coloredBarPlayerButtons()} />
                </div>
                break;
            case AAF_CONTENT_IS_VOD:
            case AAF_CONTENT_IS_NPVR:
                colored = <div ref="coloredBarControls" id="coloredBarWrapper" className="player-controls-colored-bar-controls-alt1">
                    <ColoredBar getNavigation={this.getColoredBarControlsNavigation} type="tabs" buttons={this.coloredBarPlayerButtons()} />
                </div>
                break;
            default:
                break;
        }

        return (
            <div className={`${focusZone}`}>
                {colored}
            </div>
        );
    }

    skipIntroControl(langsChapter, isResumeAfterIntro = false, resumeSecond = 0) {
        resumeSecond = parseInt(resumeSecond);
        console.log('[SKI] PC skipIntroControl enter isResumeAfterIntro', isResumeAfterIntro);
        if (langsChapter.length > 0 && !this.isTrailer()) {
            console.log('[SKI] PC skipIntroControl tengo lenguages');
            const currentLang = DeviceStorage.getItem('default_lang');
            const hasSkipIntro = langsChapter[0].intro_finish_time !== null && langsChapter[0].intro_start_time !== null;
            if (hasSkipIntro) {
                console.log('[SKI] PC skipIntroControl, hasSkipIntro = true');
                this.currentLangChapter = langsChapter.filter(
                    lang => lang.option_id === currentLang
                );
                console.log('[SKI] PC skipIntroControl, this.currentLangChapter: ', this.currentLangChapter);
                console.log('[SKI] PC skipIntroControl, startTime: ', this.currentLangChapter[0].intro_start_time);
                console.log('[SKI] PC skipIntroControl, endTime: ', this.currentLangChapter[0].intro_finish_time);

                const addSkip = this.getAdditionalautoHideSkipSeconds();
                let endTimeSkipDefault = addSkip;
                if (this.currentLangChapter[0]) {
                    let introStartTime = parseInt(this.currentLangChapter[0].intro_start_time);
                    let introEndTime = parseInt(this.currentLangChapter[0].intro_finish_time);

                    endTimeSkipDefault = introStartTime + parseInt(addSkip);

                    if (resumeSecond > 0 && !isResumeAfterIntro) {
                        if (resumeSecond >= introStartTime && resumeSecond <= introEndTime) {
                            endTimeSkipDefault = resumeSecond + parseInt(addSkip);
                        }
                    }

                    if (endTimeSkipDefault > this.currentLangChapter[0].intro_finish_time) {
                        endTimeSkipDefault = parseInt(this.currentLangChapter[0].intro_finish_time);
                    }
                }
                console.log('[SKI] PC skipIntroControl, endTimeCalculated: ', endTimeSkipDefault);

                console.log('[SKI] PC skipIntroControl enter isResumeAfterIntro', isResumeAfterIntro);

                if (settings.player_controls_enable_screen_seconds) {
                    this.refs['ctimeskip'].innerHTML = `${this.currentLangChapter[0].intro_start_time} - ${this.currentLangChapter[0].intro_finish_time}`;
                }

                this.setState({
                    hasSkipIntro: true,
                    skipIntroStartTime: this.currentLangChapter[0] && this.currentLangChapter[0].intro_start_time,
                    skipIntroEndTime: this.currentLangChapter[0] && this.currentLangChapter[0].intro_finish_time,
                    skipIntroCalculatedEndTime: endTimeSkipDefault,
                    justWasSkipIntroShowedFirstTime: isResumeAfterIntro,
                    justWasSkipIntroClosedFirstTime: isResumeAfterIntro
                });
            }
            else {
                this.setState({
                    hasSkipIntro: false,
                    skipIntroVisible: false,
                    skipIntroStartTime: 0,
                    skipIntroEndTime: 0,
                    skipIntroCalculatedEndTime: 0,
                    justWasSkipIntroShowedFirstTime: isResumeAfterIntro,
                    justWasSkipIntroClosedFirstTime: isResumeAfterIntro
                });
            }
        }
        else {
            this.setState({
                hasSkipIntro: false,
                skipIntroVisible: false,
                skipIntroStartTime: 0,
                skipIntroEndTime: 0,
                skipIntroCalculatedEndTime: 0,
                justWasSkipIntroShowedFirstTime: isResumeAfterIntro,
                justWasSkipIntroClosedFirstTime: isResumeAfterIntro
            });
        }
    }

    getAdditionalautoHideSkipSeconds() {
        const addTime = Utils.getApaMetadataKey('additional_autoHide_skipIntro_seconds', 7);
        console.log('[SKI] additional_autoHide_skipIntro_seconds: ', addTime);

        return addTime;
    }

    /**
     * Este método sólo revisa si hay skipIntro en el contenido y
     * si es así, sólo verifica que el currentTime este DENTRO del rango en que se debe mostrar el
     * skip intro button
     *
     * No hace mayores verificaciones y es sólo para ser llamado en el método show para mostrar player controls
     * (NO verifica por modal en pantalla por ej., no es necesario en este momento, suficiente para los fines arriba mencionados)
     */
    shouldShowSkipIntro() {
        if (this.state.contentStreamType !== AAF_CONTENT_IS_VOD) return false;
        if (this.state.skipIntroVisible) return false;
        if (!this.state.hasSkipIntro) return false;

        const curTime = this.getCurrentTime();

        return this.state.hasSkipIntro
            && curTime >= this.state.skipIntroStartTime
            && curTime <= this.state.skipIntroEndTime;
    }

    /**
     * Este método sólo revisa si hay skipIntro en el contenido y si esta visible y
     * si es así, sólo verifica que el currentTime este FUERA del rango en que se debe mostrar el
     * skip intro button
     *
     * No hace mayores verificaciones y es sólo para ser llamado en el método hide para ocultar player controls
     * (NO verifica por modal en pantalla por ej., no es necesario en este momento, suficiente para los fines arriba mencionados)
     */
    shouldHideSkipIntro() {
        if (this.state.contentStreamType !== AAF_CONTENT_IS_VOD) return false;
        if (!this.state.hasSkipIntro) return false;
        // Si esta visible, se cierra
        // Si no se ha cerrado la primera vez el skip, entonces se deja en pantalla
        return this.state.skipIntroVisible && this.state.justWasSkipIntroClosedFirstTime;
    }

    calculateendSkipIntro() {
        let endTimeSkipIntro = 0;
        if (this.state.hasSkipIntro) {
            const curTime = this.getCurrentTime();
            // Si es la primera vez que entra


        }

        return endTimeSkipIntro;
    }

    handleSkipIntro() {
        if (this.state.hasSkipIntro) {
            // Si hay modal en pantalla, no se lanza el skip
            const modal = document.getElementsByClassName('modal-overlay');
            const curTime = this.getCurrentTime();

            if (curTime >= this.state.skipIntroStartTime && curTime <= this.state.skipIntroCalculatedEndTime) {
                if (modal.length === 0) {
                    if (!this.state.justWasSkipIntroShowedFirstTime) {
                        // Si el user esta haciendo backward/forward con los botones o progress bar
                        // entonces el skip intro no se muestra, hasta que deje de adelantar o atrasar.
                        // Si el skip intro no se había mostrado antes se muestra, si no se esta moviendo se muestra
                        !this.isMoving && this.showSkipIntro(false);
                    }
                    else {
                        // Si ya se mostró previamente el skip intro, entonces ahora sólo
                        // se mostrará si PC esta visible
                        if (this.state.visible) {
                            this.showSkipIntro(false);
                        }
                    }
                }
                else {
                    this.hideSkipIntro(true);
                }
            } else if (this.state.skipIntroVisible && (curTime > this.state.skipIntroCalculatedEndTime || curTime < this.state.skipIntroStartTime)) {
                this.hideSkipIntro();
            }
        }
    }

    /**
     * calledFromShowPlayer = true => fue llamado desde show() de manera manual al mostrar player
     * calledFromShowPlayer = false => fue llamado de manera automática, de acuerdo al current time
     */
    showSkipIntro(calledFromShowPlayer) {
        console.log('[SKI] showSkipIntro enter');
        if (!this.state.skipIntroVisible) {
            // Se guarda que ya se mostró player controls por primera vez
            let isFirstTime = this.state.justWasSkipIntroShowedFirstTime;
            let justWasSkipIntroShowedFirstTime = this.state.justWasSkipIntroShowedFirstTime;
            if (!justWasSkipIntroShowedFirstTime) {
                justWasSkipIntroShowedFirstTime = !justWasSkipIntroShowedFirstTime;
            }
            this.setState({ skipIntroVisible: true, justWasSkipIntroShowedFirstTime }, () => {
                this.playerControlsActivityNotifier.sendActivity(new PlayerControlsActivity(SHOW_SKIP_INTRO_EVENT, { calledFromShowPlayer }));
                this.enableFocus(SKIPINTRO_FOCUS_ZONE);
                setTimeout(() => {
                    // window.SpatialNavigation.focus('.skip-intro-button');
                    // window.SpatialNavigation.focus('#skipIntroButton');
                    console.log('[SKI] se muestra skip intro button, después de hacer el stetState: ', this.state);
                    // Si la barra de player controls esta activa no se focusea botón de skip
                    if (!this.state.visible) {
                        console.log('[SKI] se muestra skip intro button se le pone el foco');
                        this.focus('.skip-intro-button');
                        // A partir de que se muestra se calcula el tiempo en pantalla?
                    }
                    this.managePlayerControlsSkipIntroFocus();
                }, 200);
            });
        }
    }

    /**
     *
     * @param {*} forceState Es true para forzar el setState, útil cuando
     * esta una modal en pantalla y se intenta mostrar el skip
     */
    hideSkipIntro(forceState = false) {
        const currentFocused = this.getCurrentFocusedElement();
        console.log('[SKI] hideSkipIntro Tengo skipIntro');

        // Se guarda que ya se cerró player controls por primera vez
        let justWasSkipIntroClosedFirstTime = this.state.justWasSkipIntroClosedFirstTime;
        if (!justWasSkipIntroClosedFirstTime) {
            justWasSkipIntroClosedFirstTime = !justWasSkipIntroClosedFirstTime;
        }

        // Si ya esta hide ya no se actualiza el estado
        if (!this.state.skipIntroVisible && !forceState) return;

        this.setState({
            skipIntroVisible: false,
            justWasSkipIntroClosedFirstTime
        }, () => {
            this.disableFocus(SKIPINTRO_FOCUS_ZONE);
            this.managePlayerControlsSkipIntroFocus();
            if (this.state.visible) {
                if (currentFocused
                    && currentFocused.className.indexOf('skip-intro-button') !== -1) {
                    this.focus(this.state.playing ? '.video-player-control-main-button-pause' : '.video-player-control-main-button-play');
                }
            }
        });
    }

    doSkipIntro(e) {
        console.log('[SKI] doSkipIntro enter');
        e.preventDefault();
        e.stopPropagation();
        console.log('[SKI] enter doSkipIntro');
        if (!this.canPlay) return;

        PlayerControlsLogic.sendMetric('control player', 'omitir intro', this.props.dataMetric, this.props.setMetricsEvent, false, this.getCurrentTimeInMinutes(), this.getDurationInMinutes(), 'reproductor');

        // Aqui puedo mandar llamar a hideSkipIntro, pero
        // mejor hago el setState para tener en sync todo
        this.setState({
            skipIntroVisible: false,
            justWasSkipIntroShowedFirstTime: true,
            justWasSkipIntroClosedFirstTime: true
        }, () => {
            this.disableFocus(SKIPINTRO_FOCUS_ZONE);
            if (!this.state.playing) this.props.play();
            this.seek(parseInt(this.state.skipIntroEndTime));
        });
    }

    managePlayerControlsSkipIntroFocus() {
        console.log('[SKI] managePlayerControlsSkipIntroFocus enter');
        // Verificar si es vod y si es vod verificar por el skip intro, si esta visible
        // se debe de agregar que el foco se pueda mover hacía este botón
        if (this.state.contentStreamType === AAF_CONTENT_IS_VOD) {
            // El botón de la extrema derecha es #pc0 en PC
            const PCButtonAtLeft = document.getElementById('pc0');
            const skipIntroButton = document.getElementById('skipIntroButton');

            if (this.state.visible) {
                if (this.state.skipIntroVisible) {
                    console.log('[SKI] managePlayerControlsSkipIntroFocus playerControls, skipIntro visible');
                    PCButtonAtLeft && PCButtonAtLeft.setAttribute('data-sn-left', '#skipIntroButton');
                    skipIntroButton && skipIntroButton.setAttribute('data-sn-right', '#pc0');
                }
                else {
                    console.log('[SKI] managePlayerControlsSkipIntroFocus playerControls visible, skipIntro NO visible');
                    PCButtonAtLeft && PCButtonAtLeft.setAttribute('data-sn-left', '');
                    skipIntroButton && skipIntroButton.setAttribute('data-sn-right', '');
                }
            }
            else {
                if (this.state.skipIntroVisible) {
                    console.log('[SKI] managePlayerControlsSkipIntroFocus playerControls NO visible, skipIntro visible');
                    skipIntroButton && skipIntroButton.setAttribute('data-sn-right', '');
                }
            }
        }
    }

    getCurrentFocusedElement() {
        const activeElement = document.activeElement;
        if (activeElement && activeElement !== document.body) {
            return activeElement;
        }
        return null;
    }

    initSpriteConfig = () => {
        this.spriteShown = 'hidden';
        this.imageSprite = new Image();
        this.imageSprite.crossOrigin = 'Anonymous';
        //this.imageSpriteURL = '';
        //this.imageSpriteURLnew = '';
        this.shouldSpriteShow = false;
    };

    onUpdateSprite(image_sprites) {
        this.contentSprite = null;
        this.shouldSpriteShow = false;
        this.spriteShown = 'hidden';
        this.proporcion = 0;

        if (this.state.contentStreamType !== AAF_CONTENT_IS_VOD) return;
        if (this.isTrailer()) return;
        if (!this.areSpritesSupportedOnThisDevice()) return;

        this.contentSprite = image_sprites;
        // esto es necesario porque en STBs como kaon, coship, huawei si es el mismo src no vuelve ejecutar el onload y la bandera shouldSpriteShow no se prende
        this.imageSprite.src = '';
        this.imageSprite.src = this.contentSprite;
        this.proporcion = 0;

        if (this.contentSprite) {
            this.imageSprite.onload = () => {
                this.shouldSpriteShow = this.canShowSprites();
            };
        }
    }

    areSpritesSupportedOnThisDevice() {
        const modelDetection = ModelDetection.getDeviceDescription();
        const modelDevice = modelDetection.modelDevice;
        const platform = modelDetection.platform;
        let result;

        const device = modelDevice === null ? platform : modelDevice;
        console.log('[NPC][deviceDescription]', modelDetection);

        switch (device) {
            case 'ps4':
            case 'hisense':
            case 'samsung-hybrid':
            case 'sony-bravia':
                result = false;
                break;
            default:
                result = true;
                break;
        }

        return result;
    }

    canShowSprites() {
        let result = false;
        if (this.contentSprite && this.refs.sprite && this.refs.sprite.getContext) {
            let ctx = this.refs.sprite.getContext('2d');
            const frame_width = 200;
            const frame_height = 113;
            const maxRow = 10;
            let fraccion = 1 / 8;
            let count_fraccionado = 0;

            ctx.canvas.height = frame_height;
            ctx.canvas.width = frame_width;
            try {
                //this.isPixelEmpty(ctx.getImageData(0, 0, 1 , 1));
                if (this.proporcion == 0) {
                    ctx.drawImage(
                        this.imageSprite,
                        frame_width * (maxRow - 1),
                        0,
                        frame_width,
                        frame_height,
                        0,
                        0,
                        frame_width,
                        frame_height
                    );
                    this.proporcion = 1;
                    while (
                        this.isPixelEmpty(ctx.getImageData(190, 0, 1, 1)) &&
                        this.proporcion >= 0
                    ) {
                        count_fraccionado++;
                        this.proporcion = 1 - count_fraccionado * fraccion;
                        console.log('CANVAS PROPORCION: ', this.proporcion);
                        ctx.drawImage(
                            this.imageSprite,
                            frame_width * this.proporcion * (maxRow - 1),
                            0,
                            frame_width * this.proporcion,
                            frame_height * this.proporcion,
                            0,
                            0,
                            frame_width,
                            frame_height
                        );
                    }
                }
                if (this.proporcion > 1 - 3 * fraccion) {
                    //Solo se redujo a lo más en 2/8 la resolución
                    result = true;
                }
            } catch (error) {
                console.error(
                    `Images are not found in route:"${this.imageSprite.src}" ... ${error}`
                );
            }
        }

        return result;
    }

    updateSprite(currentTime) {
        if (this.spriteShown === 'visible' && this.imageSprite.src) {
            let ctx = this.refs.sprite.getContext('2d');
            currentTime = currentTime / 10;
            const frame_width = 200;
            const frame_height = 113;
            const maxRow = 10;
            let rowLength = frame_width;
            let row = Math.round(parseInt(currentTime / 10));
            let column = Math.round(parseInt((currentTime % rowLength) % 10));
            console.log('SPRITE ROW:' + row);
            console.log('SPRITE ROW_LENGHT:' + rowLength);
            console.log('SPRITE CurrentTime:' + currentTime);
            console.log('SPRITE COLUMN:' + column);
            console.log('SPRITE height:' + this.imageSprite.height);
            console.log('SPRITE width:' + this.imageSprite.width);
            console.log('CANVAS height:' + this.canvasHeight);
            ctx.canvas.height = frame_height;
            ctx.canvas.width = frame_width;
            try {
                if (this.proporcion > 1 - 3 / 8) {
                    console.log('SPRITE drawImage ');

                    //Solo se redujo a lo más en 2/8 la resolución
                    ctx.drawImage(
                        this.imageSprite,
                        frame_width * this.proporcion * column,
                        frame_height * this.proporcion * row,
                        frame_width * this.proporcion,
                        frame_height * this.proporcion,
                        0,
                        0,
                        frame_width,
                        frame_height
                    );
                }
            } catch (error) {
                console.error(
                    `SPRITE Images are not found in route:"${this.imageSprite.src}" ... ${error}`
                );
            }
        }
    }

    isPixelEmpty(imgData) {
        const red = imgData.data[0];
        const green = imgData.data[1];
        const blue = imgData.data[2];
        const alpha = imgData.data[3];
        console.log('COLORS:' + red + ' ' + green + ' ' + blue + ' ' + alpha);

        return red === 0 && green === 0 && blue === 0 && alpha === 0;
    }

    showSprites() {
        if (
            this.shouldSpriteShow &&
            !this.isTrailer() &&
            this.state.contentStreamType === AAF_CONTENT_IS_VOD &&
            !store.getState().user.isAnonymous
        ) {
            this.spriteShown = 'visible';
        }
    }

    hideSprites() {
        this.spriteShown = 'hidden';
    }

    getCurrentTimeAsString() {
        return '00:00:00*';
    }

    // updateCurrentTimeSprite(time) {
    //     const timeStr = this.getCurrentTimeAsString(time);
    //     this.refs.currentTimeSprite.innerHTML = timeStr;
    // }

    updateSpritePosition() {
        const refSlider = this.refs.playerControls.refs.playerSlider.refs.ball;
        const position = this.getAbsoluteElementPosition('player-ui-progress-bar-ball');
        this.refs.sprite.style.left = `${position.left - (this.refs.sprite.offsetWidth / 2 - refSlider.offsetWidth / 2)}px`;
        this.refs.sprite.style.top = `${position.top - 130}px`;
        this.refs.sprite.style.visibility = `${this.spriteShown}`;

        // En el brief de player VOD no hay tiempo sobre los sprites
        // this.refs.currentTimeSprite.style.visibility = `${this.spriteShown}`;
        // this.refs.currentTimeSprite.style.left = `${position.left -
        //     (this.refs.currentTimeSprite.offsetWidth / 2 -
        //         refSlider.offsetWidth / 2)}px`;
        // this.refs.currentTimeSprite.style.top = `${position.top - 60}px`;
    }

    getAbsoluteElementPosition(idOfElement) {
        let element = document.getElementById(idOfElement);

        if (!element) return { top: 0, left: 0 };

        let y = 0;
        let x = 0;
        while (element.offsetParent) {
            x += element.offsetLeft;
            y += element.offsetTop;
            element = element.offsetParent;
        }
        return { top: y, left: x };
    }

    getPlayerControlsButtonNavigation(idx, items, pc = true) {
        let nav = {
            left: '',
            right: '',
            down: '',
            up: ''
        };

        if (!Array.isArray(items)) return nav;
        if (items.length < 1) return nav;
        if (idx < 0 || idx >= items.length) return nav;
        if (!items[idx] || !items[idx].enabled) return nav;

        if (idx >= 0 && idx < items.length) {
            // Nav a la izquierda
            let i = idx - 1;
            while (i > -1) {
                if (items[i].enabled) {
                    nav.left = `#pc${i}`;
                    break;
                }
                i--;
            }
            // Nav a la derecha
            i = idx + 1;
            while (i < items.length) {
                if (items[i].enabled) {
                    nav.right = `#pc${i}`;
                    break;
                }
                i++;
            }
            // Nav arriba
            if (pc) {
                nav.up = "#player-ui-progress-bar-ball";
                nav.down = `@${COLOREDBAR_FOCUS_ZONE_PLAYERCONTROLS}`;
            }
        }

        return nav;
    }

    getColoredBarControlsNavigation(idx, items) {
        return this.getColoredBarButtonsNavigation(idx, items, true);
    }

    getColoredBarButtonsNavigation(idx, items, isPc) {
        let nav = {
            left: '',
            right: '',
            down: '',
            up: ''
        };

        if (!Array.isArray(items)) return nav;
        if (items.length < 1) return nav;
        if (idx < 0 || idx >= items.length) return nav;

        if (idx >= 0 && idx < items.length) {
            // Nav a la izquierda
            let i = idx - 1;
            while (i > -1) {
                if (items[i]) {
                    nav.left = `#cb${i}` + (isPc ? 'PC' : 'MINI');
                    break;
                }
                i--;
            }
            // Nav a la derecha
            i = idx + 1;
            while (i < items.length) {
                if (items[i]) {
                    nav.right = `#cb${i}` + (isPc ? 'PC' : 'MINI');
                    break;
                }
                i++;
            }
            // Nav arriba
            nav.up = ".video-player-control-main-button";
            nav.down = '';
        }

        return nav;
    }

    showNotificationNoSlide() {
        store.dispatch(showPlayerBackwardForwardNotAvailableNotification());
    }

    render() {
        console.log('[NPC] PlayerControls render');
        return (
            <div>

                {settings.player_controls_enable_screen_seconds && <div className="test-ct" >
                    <div ref="ctime"></div>
                    <div ref="ctimeskip"></div>
                </div>}

                <div className="" ref="channelNumber" />
                <div ref="miniEpgContainer" className="player-controls-mini-epg-hide">
                    {this.getMiniEpg()}
                    {this.getColoredMini()}
                </div>
                <div ref="playerControlsContainer" className="player-controls-hide">
                    <div className="player-controls-container" id="n_player_controls">
                        {
                            this.state.contentStreamType === AAF_CONTENT_IS_VOD ?
                                (<div>
                                    <canvas
                                        id="player-controls-progress-bar-sprite"
                                        className="player-controls-progress-bar-sprite"
                                        ref="sprite"
                                    />
                                </div>)
                                : null
                        }
                        {this.getPlayerControls()}
                    </div>
                    <div>
                        {this.getColoredControls()}
                    </div>
                </div>
                {
                    this.state.contentStreamType === AAF_CONTENT_IS_VOD && this.state.skipIntroVisible &&
                    <div className="player-controls-skipintro-container">
                        <SkipIntro onClick={this.doSkipIntro} />
                    </div>
                }
            </div>
        );
    }
}

export const playerControlsIsVisible = () => PlayerControls.isVisible;

export default PlayerControls;



// WEBPACK FOOTER //
// ./src/playerDomain/components/PlayerControls.js